export default {
    units: [
        { text: "kg", value: "kg" },
        { text: "m", value: "m" },
        { text: "l", value: "l" },
        { text: "m²", value: "m²" },
        { text: "m³", value: "m³" },
        { text: "unité", value: "unité" }
    ],
    simpleVersionSteps: [
        {
            title: "Vous et votre projet",
            id: 1,
            show: false,
            done: false,
            pathName: "vous_et_votre_projet",
            subSteps: [
                {
                    title: "Profils des investisseurs",
                    done: false,
                    focus: false,
                    pathName: "profils_des_investisseurs"
                },
                {
                    title: "Votre projet",
                    done: false,
                    focus: false,
                    pathName: "votre_entreprise"
                }
            ]
        },
        {
            title: "Étude de marché",
            id: 2,
            show: false,
            pathName: "etude_de_marche",
            done: false,
            subSteps: [
                {
                    title: "Taille et évolution du marché",
                    done: false,
                    focus: false,
                    pathName: "taille_et_evolution_du_marche"
                },
                {
                    title: "Analyse Concurrentielle",
                    done: false,
                    focus: false,
                    pathName: "analyse_concurrentielle"
                },
                {
                    title: "Répartition Géographique",
                    done: false,
                    focus: false,
                    pathName: "geographical_distribution"
                }
            ]
        },
        {
            title: "Étude Technique",
            id: 3,
            show: false,
            pathName: "etude_technique",
            done: false,
            subSteps: [
                {
                    title: "Moyens fonciers et immeubles",
                    done: false,
                    focus: false,
                    pathName: "moyens_fonciers_et_immeubles"
                },
                {
                    title: "Moyens d’exploitation",
                    done: false,
                    focus: false,
                    pathName: "i_t_m_o"
                },
                {
                    title: "Moyens humains",
                    done: false,
                    focus: false,
                    pathName: "moyens_humains"
                }
            ]
        },
        {
            title: "Étude Financière",
            id: 4,
            show: false,
            pathName: "etude_financiere",
            done: false,
            subSteps: [
                {
                    title: "Programme d’investissement plan de financement",
                    done: false,
                    focus: false,
                    pathName: "programme_dinvestissement_et_plan_de_financement"
                },
                {
                    title: "Chiffres d’affaires Prévisionnels",
                    done: false,
                    focus: false,
                    pathName: "chiffres_daffaires_previsionnels"
                },
                {
                    title: "Charges Prévisionnels",
                    done: false,
                    focus: false,
                    pathName: "Charges_previsionnels"
                }
            ]
        }
    ],
    steps: [
        {
            title: "Vous et votre projet",
            id: 1,
            show: false,
            done: false,
            pathName: "vous_et_votre_projet",
            subSteps: [
                {
                    title: "Profils des investisseurs",
                    done: false,
                    focus: false,
                    pathName: "profils_des_investisseurs"
                },
                {
                    title: "Votre projet",
                    done: false,
                    focus: false,
                    pathName: "votre_entreprise"
                }
            ]
        },
        {
            title: "Étude de marché",
            id: 2,
            show: false,
            pathName: "etude_de_marche",
            done: false,
            subSteps: [
                {
                    title: "Taille et évolution du marché",
                    done: false,
                    focus: false,
                    pathName: "taille_et_evolution_du_marche"
                },
                {
                    title: "Santé financière Des entreprises",
                    done: false,
                    focus: false,
                    pathName: "sante_financiere_des_entreprises"
                },
                {
                    title: "Principaux acteurs et part du marché",
                    done: false,
                    focus: false,
                    pathName: "principaux_acteurs_et_part_du_marche"
                },
                {
                    title: "Analyse Concurrentielle",
                    done: false,
                    focus: false,
                    pathName: "analyse_concurrentielle"
                },
                {
                    title: "Moyens Commerciaux",
                    done: false,
                    focus: false,
                    pathName: "moyens_commerciaux"
                }
            ]
        },
        {
            title: "Étude Technique",
            id: 3,
            show: false,
            pathName: "etude_technique",
            done: false,
            subSteps: [
                {
                    title: "Moyens fonciers et immeubles",
                    done: false,
                    focus: false,
                    pathName: "moyens_fonciers_et_immeubles"
                },
                {
                    title: "Moyens d’exploitation",
                    done: false,
                    focus: false,
                    pathName: "installations_techniques"
                },
                {
                    title: "Moyens humains",
                    done: false,
                    focus: false,
                    pathName: "moyens_humains"
                }
            ]
        },
        {
            title: "Étude Financière",
            id: 4,
            show: false,
            pathName: "etude_financiere",
            done: false,
            subSteps: [
                {
                    title: "Programme d’investissement plan de financement",
                    done: false,
                    focus: false,
                    pathName: "programme_dinvestissement_plan_de_financement"
                },
                {
                    title: "Chiffres d’affaires Prévisionnels",
                    done: false,
                    focus: false,
                    pathName: "chiffres_daffaires_previsionnels"
                },
                {
                    title: "Achats Prévisionnels",
                    done: false,
                    focus: false,
                    pathName: "achats_previsionnels"
                },
                {
                    title: "Autres charges externes",
                    done: false,
                    focus: false,
                    pathName: "autres_charges_externes"
                },
                {
                    title: "Charges du personnel",
                    done: false,
                    focus: false,
                    pathName: "charges_du_personnel"
                }
            ]
        }
    ],

    steppers: [
        {
            title: "Installations techniques",
            isCompleted: false,
            current: false,
            path: "installations_techniques"
        },
        {
            title: "Matériels et outillage",
            isCompleted: false,
            current: false,
            path: "materiels_et_outillage"
        },
        {
            title: "Moyens de transports et manutentions",
            isCompleted: false,
            current: false,
            path: "moyens_de_transports_et_manutentions"
        },
        {
            title: "Mobilier et bureaux",
            isCompleted: false,
            current: false,
            path: "mobilier_et_bureaux"
        },
        {
            title: "Matériel Informatique",
            isCompleted: false,
            current: false,
            path: "materiel_informatique"
        }
    ],
    votreProjectSteepers: [
        {
            title: "Votre Entreprise",
            isCompleted: false,
            current: false,
            path: "votre_entreprise"
        },
        {
            title: "Votre Projet",
            isCompleted: false,
            current: false,
            path: "_votre_projet"
        },
        {
            title: "Vos Offres",
            isCompleted: false,
            current: false,
            path: "vos_offres"
        },
        {
            title: "Vos Clients",
            isCompleted: false,
            current: false,
            path: "vos_clients"
        }
    ],

    ProfilsDesInvestisseurs: {
        motivationOptions: [
            { name: "Etre indépendant", code: "1" },
            {
                name: "Une nouvelle idée de produit, de service ou de marché",
                code: "2"
            },
            {
                name:
                    "Le goût d’entrepreneuriat et le désir d’affronter de nouveau défis",
                code: "3"
            },
            {
                name: "Je suis sans emploi, et je veux créer mon propre emploi",
                code: "4"
            },
            {
                name: "Mon entourage à réussi dans l’entreprenariat",
                code: "5"
            },
            { name: "Augmenter mes revenus", code: "6" },
            {
                name: "La seule possibilité pour exercer ma profession",
                code: "7"
            },
            { name: "Une opportunité d’affaire", code: "8" }
        ],
        formationList: [
            { text: "Primaire", value: "Primaire" },
            { text: "Secondaire", value: "Secondaire" },
            {
                text: "Formation professionnelle",
                value: "Formation professionnelle"
            },
            { text: "Supérieur", value: "Supérieur" },
            { text: "Autre (à préciser)", value: "autre" }
        ],
        expProList: [
            {
                text:
                    "Je dispose d’une expérience professionnelle dans ce domaine",
                value:
                    "Je dispose d’une expérience professionnelle dans ce domaine"
            },
            {
                text: "Sans expérience",
                value: "Sans expérience"
            },
            {
                text:
                    "Je dispose d’une expérience professionnelle dans un autre domaine (à préciser)",
                value: "autre"
            }
        ],
        situationFamilialeLis: [
            {
                text: "Marié(e)",
                value: "Marié"
            },
            {
                text: "Célibataire",
                value: "Célibataire"
            },
            {
                text: " Autre",
                value: "Autre"
            }
        ]
    },
    VotreProject: {
        FormeJuridiqueList: [
            { text: "SARL", value: "Sarl" },
            { text: "SARL AU", value: "SARL AU" },
            { text: "AE", value: "AE" },
            { text: "Coopérative", value: "coopérative" },
            { text: "Non défini", value: "Non défini" }
        ],
        Sectors: [
            {
                value: 1,
                temp_id: "A",
                text: "Agriculture, chasse, sylviculture",
                parent: null
            },
            {
                value: 2,
                temp_id: "B",
                text: "Pêche, aquaculture",
                parent: null
            },
            {
                value: 3,
                temp_id: "C",
                text: "Industries extractives",
                parent: null
            },
            {
                value: 4,
                temp_id: "D",
                text: "Industries manufacturières",
                parent: null
            },
            {
                value: 5,
                temp_id: "E",
                text:
                    "Production et distribution d'électricité, de gaz et d'eau",
                parent: null
            },
            {
                value: 6,
                temp_id: "F",
                text: "Bâtiment et travaux publics",
                parent: null
            },
            {
                value: 7,
                temp_id: "G",
                text:
                    "Commerce; réparations automobile et d'articles domestiques",
                parent: null
            },
            {
                value: 8,
                temp_id: "H",
                text: "Hôtels et Restaurants",
                parent: null
            },
            {
                value: 9,
                temp_id: "I",
                text: "Transports et Communications",
                parent: null
            },
            {
                value: 10,
                temp_id: "J",
                text: "Activités financières",
                parent: null
            },
            {
                value: 11,
                temp_id: "K",
                text: "Immobiliers, location et services aux entreprises",
                parent: null
            },
            {
                value: 12,
                temp_id: "L",
                text: "Administration publique",
                parent: null
            },
            { value: 13, temp_id: "M", text: "Education", parent: null },
            {
                value: 14,
                temp_id: "N",
                text: "Santé et action sociale",
                parent: null
            },
            {
                value: 15,
                temp_id: "O",
                text: "Services collectifs, sociaux et personnels",
                parent: null
            },
            {
                value: 16,
                temp_id: "P",
                text: "Services domestiques",
                parent: null
            },
            {
                value: 17,
                temp_id: "Q",
                text: "Activités extra-territoriales",
                parent: null
            },
            {
                value: 18,
                temp_id: "A01",
                text: "Agriculture, chasse, services annexes",
                parent: 1
            },
            {
                value: 19,
                temp_id: "A02",
                text: "Sylviculture, exploitation forestière, services annexes",
                parent: 1
            },
            {
                value: 20,
                temp_id: "B05",
                text: "Pêche, aquaculture",
                parent: 2
            },
            {
                value: 21,
                temp_id: "C10",
                text: "Extraction de houille, de lignite et de tourbe",
                parent: 3
            },
            {
                value: 22,
                temp_id: "C11",
                text: "Extraction d'hydrocarbures, services annexes",
                parent: 3
            },
            {
                value: 23,
                temp_id: "C13",
                text:
                    "Extraction , exploitation et enrichissement de minerais métalliques",
                parent: 3
            },
            {
                value: 24,
                temp_id: "C14",
                text: "Autres industries extractives",
                parent: 3
            },
            {
                value: 25,
                temp_id: "D15",
                text: "Industries alimentaires",
                parent: 4
            },
            {
                value: 26,
                temp_id: "D16",
                text: "Industrie du Tabac",
                parent: 4
            },
            {
                value: 27,
                temp_id: "D17",
                text: "Industrie textile",
                parent: 4
            },
            {
                value: 28,
                temp_id: "D18",
                text: "Industrie de l'habillement et des fourrures",
                parent: 4
            },
            {
                value: 29,
                temp_id: "D19",
                text: "Industrie du cuir et de la chaussure",
                parent: 4
            },
            {
                value: 30,
                temp_id: "D20",
                text: "Travail du bois et fabrication d'articles en bois",
                parent: 4
            },
            {
                value: 31,
                temp_id: "D21",
                text: "Industrie du papier et du carton",
                parent: 4
            },
            {
                value: 32,
                temp_id: "D22",
                text: "Edition, imprimerie, reproduction",
                parent: 4
            },
            {
                value: 33,
                temp_id: "D23",
                text: "Cokéfaction, raffinage, industries nucléaires",
                parent: 4
            },
            {
                value: 34,
                temp_id: "D24",
                text: "Industrie chimique",
                parent: 4
            },
            {
                value: 35,
                temp_id: "D25",
                text: "Industrie du caoutchouc et des plastiques",
                parent: 4
            },
            {
                value: 36,
                temp_id: "D26",
                text: "Fabrication d'autres produits minéraux non métalliques",
                parent: 4
            },
            {
                value: 37,
                temp_id: "D27",
                text: "Métallurgie",
                parent: 4
            },
            {
                value: 38,
                temp_id: "D28",
                text: "Travail des métaux",
                parent: 4
            },
            {
                value: 39,
                temp_id: "D29",
                text: "Fabrication de machines et équipements",
                parent: 4
            },
            {
                value: 40,
                temp_id: "D30",
                text:
                    "Fabrication de machines de bureau et de matériel informatique",
                parent: 4
            },
            {
                value: 41,
                temp_id: "D31",
                text: "Fabrication de machines et appareils électriques",
                parent: 4
            },
            {
                value: 42,
                temp_id: "D32",
                text:
                    "Fabrication d'équipements de Radio, Télévision et Communication",
                parent: 4
            },
            {
                value: 43,
                temp_id: "D33",
                text:
                    "Fabrication d'instruments médicaux, de précision d'optique et d'horlogerie",
                parent: 4
            },
            {
                value: 44,
                temp_id: "D34",
                text: "Industrie automobile",
                parent: 4
            },
            {
                value: 45,
                temp_id: "D35",
                text: "Fabrication d'autres matériels de transport",
                parent: 4
            },
            {
                value: 46,
                temp_id: "D36",
                text: "Fabrication de meubles, industries diverses",
                parent: 4
            },
            {
                value: 47,
                temp_id: "D37",
                text: "Récupération",
                parent: 4
            },
            {
                value: 48,
                temp_id: "E40",
                text:
                    "Production et distribution d'électricité, de gaz et de chaleur",
                parent: 5
            },
            {
                value: 49,
                temp_id: "E41",
                text: "Captage, traitement et distribution d'eau",
                parent: 5
            },
            {
                value: 50,
                temp_id: "F45",
                text: "Construction",
                parent: 6
            },
            {
                value: 51,
                temp_id: "G50",
                text: "Commerce et réparation automobile",
                parent: 7
            },
            {
                value: 52,
                temp_id: "G51",
                text: "Commerce de gros et intermédiaires du commerce",
                parent: 7
            },
            {
                value: 53,
                temp_id: "G52",
                text: "Commerce de détail et réparation d'articles domestiques",
                parent: 7
            },
            {
                value: 54,
                temp_id: "H55",
                text: "Hôtels et Restaurants",
                parent: 8
            },
            {
                value: 55,
                temp_id: "I60",
                text: "Transports terrestres",
                parent: 9
            },
            {
                value: 56,
                temp_id: "I61",
                text: "Transports par eau",
                parent: 9
            },
            {
                value: 57,
                temp_id: "I62",
                text: "Transports aériens",
                parent: 9
            },
            {
                value: 58,
                temp_id: "I63",
                text: "Services auxiliaires des transports",
                parent: 9
            },
            {
                value: 59,
                temp_id: "I64",
                text: "Postes et télécommunications",
                parent: 9
            },
            {
                value: 60,
                temp_id: "J65",
                text: "Intermédiation financière",
                parent: 10
            },
            { value: 61, temp_id: "J66", text: "Assurance", parent: 10 },
            {
                value: 62,
                temp_id: "J67",
                text: "Auxiliaires financiers et d'assurance",
                parent: 10
            },
            {
                value: 63,
                temp_id: "K70",
                text: "Activités immobilières",
                parent: 11
            },
            {
                value: 64,
                temp_id: "K71",
                text: "Location sans opérateur",
                parent: 11
            },
            {
                value: 65,
                temp_id: "K72",
                text: "Conseil en systèmes informatiques",
                parent: 11
            },
            {
                value: 66,
                temp_id: "K73",
                text: "Recherche et développement",
                parent: 11
            },
            {
                value: 67,
                temp_id: "K74",
                text: "Services fournis principalement aux entreprises",
                parent: 11
            },
            {
                value: 68,
                temp_id: "L75",
                text: "Administration publique",
                parent: 12
            },
            { value: 69, temp_id: "M80", text: "Education", parent: 13 },
            {
                value: 70,
                temp_id: "N85",
                text: "Santé et action sociale",
                parent: 14
            },
            {
                value: 71,
                temp_id: "O90",
                text: "Assainissement, voirie et gestion de déchets",
                parent: 15
            },
            {
                value: 72,
                temp_id: "O91",
                text: "Activités associatives",
                parent: 15
            },
            {
                value: 73,
                temp_id: "O92",
                text: "Activités récréatives, culturelles et sportives",
                parent: 15
            },
            {
                value: 74,
                temp_id: "O93",
                text: "Services personnels",
                parent: 15
            },
            {
                value: 75,
                temp_id: "P95",
                text: "Services domestiques",
                parent: 16
            },
            {
                value: 76,
                temp_id: "Q99",
                text: "Activités extra-territoriales",
                parent: 17
            },
            { value: 77, temp_id: "A011", text: "Culture", parent: 18 },
            {
                value: 78,
                temp_id: "A012",
                text: "Arboriculture",
                parent: 18
            },
            { value: 79, temp_id: "A013", text: "Elevage", parent: 18 },
            {
                value: 80,
                temp_id: "A014",
                text: "Culture et élevage associés",
                parent: 18
            },
            {
                value: 81,
                temp_id: "A015",
                text: "Services annexes à l'agriculture",
                parent: 18
            },
            { value: 82, temp_id: "A016", text: "Chasse", parent: 18 },
            {
                value: 83,
                temp_id: "A020",
                text: "Sylviculture, exploitation forestière, services annexes",
                parent: 19
            },
            {
                value: 84,
                temp_id: "B050",
                text: "Pêches, aquaculture",
                parent: 20
            },
            {
                value: 85,
                temp_id: "C100",
                text: "Extraction de houille, de lignite et de tourbe",
                parent: 21
            },
            {
                value: 86,
                temp_id: "C111",
                text: "Extraction d'hydrocarbures",
                parent: 22
            },
            {
                value: 87,
                temp_id: "C112",
                text: "Services annexes à l'extraction d'hydrocarbures",
                parent: 22
            },
            {
                value: 88,
                temp_id: "C131",
                text: "Minerais de fer",
                parent: 23
            },
            {
                value: 89,
                temp_id: "C132",
                text: "Minerais de métaux non ferreux",
                parent: 23
            },
            {
                value: 90,
                temp_id: "C141",
                text: "Extraction de pierres",
                parent: 24
            },
            {
                value: 91,
                temp_id: "C142",
                text: "Extraction du sable et d'argiles",
                parent: 24
            },
            {
                value: 92,
                temp_id: "C143",
                text: "Phosphates naturels",
                parent: 24
            },
            {
                value: 93,
                temp_id: "C144",
                text: "Autres minéraux",
                parent: 24
            },
            {
                value: 94,
                temp_id: "D151",
                text: "Industrie des viandes",
                parent: 25
            },
            {
                value: 95,
                temp_id: "D152",
                text: "Industrie du poisson",
                parent: 25
            },
            {
                value: 96,
                temp_id: "D153",
                text: "Industrie des fruits et légumes",
                parent: 25
            },
            {
                value: 97,
                temp_id: "D154",
                text: "Industrie des corps gras",
                parent: 25
            },
            {
                value: 98,
                temp_id: "D155",
                text: "Industrie laitière",
                parent: 25
            },
            {
                value: 99,
                temp_id: "D156",
                text:
                    "Transformation des céréales; amidonnerie et fabrication d'aliments pour animaux",
                parent: 25
            },
            {
                value: 100,
                temp_id: "D157",
                text: "Fabrication des farines et gruaux",
                parent: 25
            },
            {
                value: 101,
                temp_id: "D158",
                text: "Autres industries alimentaires",
                parent: 25
            },
            {
                value: 102,
                temp_id: "D159",
                text: "Industries des boissons",
                parent: 25
            },
            {
                value: 103,
                temp_id: "D160",
                text: "Industrie du tabac",
                parent: 26
            },
            {
                value: 104,
                temp_id: "D171",
                text: "Filature",
                parent: 27
            },
            { value: 105, temp_id: "D172", text: "Tissage", parent: 27 },
            {
                value: 106,
                temp_id: "D173",
                text: "Ennoblissement textile",
                parent: 27
            },
            {
                value: 107,
                temp_id: "D174",
                text: "Fabrication d'articles textiles",
                parent: 27
            },
            {
                value: 108,
                temp_id: "D175",
                text: "Fabrication de tapis et autres industries textiles",
                parent: 27
            },
            {
                value: 109,
                temp_id: "D176",
                text: "Fabrication d'étoffes à maille",
                parent: 27
            },
            {
                value: 110,
                temp_id: "D177",
                text: "Fabrication d'articles à maille",
                parent: 27
            },
            {
                value: 111,
                temp_id: "D181",
                text: "Fabrication de vêtements en cuir",
                parent: 28
            },
            {
                value: 112,
                temp_id: "D182",
                text: "Fabrication de vêtements en textile",
                parent: 28
            },
            {
                value: 113,
                temp_id: "D183",
                text: "Industrie des fourrures",
                parent: 28
            },
            {
                value: 114,
                temp_id: "D191",
                text: "Apprêt et tannage des cuirs",
                parent: 29
            },
            {
                value: 115,
                temp_id: "D192",
                text: "Fabrication d'articles de voyage et de maroquinerie",
                parent: 29
            },
            {
                value: 116,
                temp_id: "D193",
                text: "Fabrication de chaussures",
                parent: 29
            },
            {
                value: 117,
                temp_id: "D201",
                text: "Sciage, rabotage, imprégnation du bois",
                parent: 30
            },
            {
                value: 118,
                temp_id: "D202",
                text: "Fabrication de panneaux de bois",
                parent: 30
            },
            {
                value: 119,
                temp_id: "D203",
                text: "Fabrication de charpentes et de menuiseries",
                parent: 30
            },
            {
                value: 120,
                temp_id: "D204",
                text: "Fabrication d'emballages en bois",
                parent: 30
            },
            {
                value: 121,
                temp_id: "D205",
                text: "Fabrication d'objets divers en bois, liège ou vannerie",
                parent: 30
            },
            {
                value: 122,
                temp_id: "D211",
                text: "Fabrication de pâte à papier, de papier et de carton",
                parent: 31
            },
            {
                value: 123,
                temp_id: "D212",
                text: "Fabrication d'articles en papier ou en carton",
                parent: 31
            },
            { value: 124, temp_id: "D221", text: "Edition", parent: 32 },
            {
                value: 125,
                temp_id: "D222",
                text: "Imprimerie",
                parent: 32
            },
            {
                value: 126,
                temp_id: "D223",
                text: "Reproduction d'enregistrements",
                parent: 32
            },
            {
                value: 127,
                temp_id: "D231",
                text: "Cokéfaction",
                parent: 33
            },
            {
                value: 128,
                temp_id: "D232",
                text: "Raffinage de pétrole",
                parent: 33
            },
            {
                value: 129,
                temp_id: "D233",
                text: "Elaboration et transformation de matières nucléaires",
                parent: 33
            },
            {
                value: 130,
                temp_id: "D241",
                text: "Industrie chimique de base",
                parent: 34
            },
            {
                value: 131,
                temp_id: "D242",
                text: "Fabrication de produits agrochimiques",
                parent: 34
            },
            {
                value: 132,
                temp_id: "D243",
                text: "Fabrication de peintures et vernis",
                parent: 34
            },
            {
                value: 133,
                temp_id: "D244",
                text: "Industrie pharmaceutique",
                parent: 34
            },
            {
                value: 134,
                temp_id: "D245",
                text:
                    "Fabrication de savons, de parfums et de produits d'entretien",
                parent: 34
            },
            {
                value: 135,
                temp_id: "D246",
                text: "Fabrication d'autres produits chimiques",
                parent: 34
            },
            {
                value: 136,
                temp_id: "D247",
                text: "Fabrication de fibres artificielles ou synthétiques",
                parent: 34
            },
            {
                value: 137,
                temp_id: "D251",
                text: "Industrie du caoutchouc",
                parent: 35
            },
            {
                value: 138,
                temp_id: "D252",
                text: "Transformation des matières plastiques",
                parent: 35
            },
            {
                value: 139,
                temp_id: "D261",
                text: "Fabrication de verre et d'articles en verre",
                parent: 36
            },
            {
                value: 140,
                temp_id: "D262",
                text: "Fabrication de produits céramiques",
                parent: 36
            },
            {
                value: 141,
                temp_id: "D263",
                text: "Fabrication de carreaux en céramique",
                parent: 36
            },
            {
                value: 142,
                temp_id: "D264",
                text: "Fabrication de tuiles et briques en terre cuite",
                parent: 36
            },
            {
                value: 143,
                temp_id: "D265",
                text: "Fabrication de ciment, chaux et plâtre",
                parent: 36
            },
            {
                value: 144,
                temp_id: "D266",
                text: "Fabrication d'ouvrages en béton ou en plâtre",
                parent: 36
            },
            {
                value: 145,
                temp_id: "D267",
                text: "Travail de la pierre",
                parent: 36
            },
            {
                value: 146,
                temp_id: "D268",
                text: "Fabrication de produits minéraux divers",
                parent: 36
            },
            {
                value: 147,
                temp_id: "D271",
                text: "Sidérurgie et production de ferro-alliages",
                parent: 37
            },
            {
                value: 148,
                temp_id: "D272",
                text: "Fabrication de tubes en fonte ou en acier",
                parent: 37
            },
            {
                value: 149,
                temp_id: "D273",
                text: "Première transformation de l'acier",
                parent: 37
            },
            {
                value: 150,
                temp_id: "D274",
                text: "Production de métaux non ferreux",
                parent: 37
            },
            {
                value: 151,
                temp_id: "D275",
                text: "Fonderie",
                parent: 37
            },
            {
                value: 152,
                temp_id: "D281",
                text: "Fabrication d'éléments en métal pour la construction",
                parent: 38
            },
            {
                value: 153,
                temp_id: "D282",
                text:
                    "Fabrication de réservoirs métalliques et de chaudières pour le chauffage central",
                parent: 38
            },
            {
                value: 154,
                temp_id: "D283",
                text: "Chaudronnerie",
                parent: 38
            },
            {
                value: 155,
                temp_id: "D284",
                text: "Forge, emboutissage, estampage; métallurgie des poudres",
                parent: 38
            },
            {
                value: 156,
                temp_id: "D285",
                text: "Traitement des métaux; mécanique générale",
                parent: 38
            },
            {
                value: 157,
                temp_id: "D286",
                text:
                    "Fabrication de coutellerie, d'outillage et de quincaillerie",
                parent: 38
            },
            {
                value: 158,
                temp_id: "D287",
                text: "Fabrication d'autres ouvrages en métaux",
                parent: 38
            },
            {
                value: 159,
                temp_id: "D291",
                text: "Fabrication d'équipements mécaniques",
                parent: 39
            },
            {
                value: 160,
                temp_id: "D292",
                text: "Fabrication de machines d'usage général",
                parent: 39
            },
            {
                value: 161,
                temp_id: "D293",
                text: "Fabrication de machines agricoles",
                parent: 39
            },
            {
                value: 162,
                temp_id: "D294",
                text: "Fabrication de machines outils",
                parent: 39
            },
            {
                value: 163,
                temp_id: "D295",
                text: "Fabrication d'autres machines d'usage spécifique",
                parent: 39
            },
            {
                value: 164,
                temp_id: "D296",
                text: "Fabrication d'armes et de munitions",
                parent: 39
            },
            {
                value: 165,
                temp_id: "D297",
                text: "Fabrication d'appareils domestiques",
                parent: 39
            },
            {
                value: 166,
                temp_id: "D300",
                text:
                    "Fabrication de mach. de bureau et de matériel informatique",
                parent: 40
            },
            {
                value: 167,
                temp_id: "D311",
                text:
                    "Fabrication de moteurs, génératrices et transformateurs électriques",
                parent: 41
            },
            {
                value: 168,
                temp_id: "D312",
                text:
                    "Fabrication de matériel de distribution et de commande électrique",
                parent: 41
            },
            {
                value: 169,
                temp_id: "D313",
                text: "Fabrication de fils et câbles isolés",
                parent: 41
            },
            {
                value: 170,
                temp_id: "D314",
                text: "Fabrication d'accumulateurs et de piles électriques",
                parent: 41
            },
            {
                value: 171,
                temp_id: "D315",
                text: "Fabrication de lampes et d'appareils d'éclairage",
                parent: 41
            },
            {
                value: 172,
                temp_id: "D316",
                text: "Fabrication d'autres matériels électriques",
                parent: 41
            },
            {
                value: 173,
                temp_id: "D321",
                text: "Fabrication de composants électroniques",
                parent: 42
            },
            {
                value: 174,
                temp_id: "D322",
                text: "Fabrication d'appareils d'émission et de transmission",
                parent: 42
            },
            {
                value: 175,
                temp_id: "D323",
                text:
                    "Fabrication d'appareils de réception, enregistrement ou reproduction du son et de l'image",
                parent: 42
            },
            {
                value: 176,
                temp_id: "D331",
                text:
                    "Fabrication de matériels médico-chirurgical et d'orthopédie",
                parent: 43
            },
            {
                value: 177,
                temp_id: "D332",
                text: "Fabrication d'instruments de mesure et de contrôle",
                parent: 43
            },
            {
                value: 178,
                temp_id: "D333",
                text:
                    "Fabrication d'équipements de contrôle des processus industriels",
                parent: 43
            },
            {
                value: 179,
                temp_id: "D334",
                text: "Fabrication de matériels optique et photographique",
                parent: 43
            },
            {
                value: 180,
                temp_id: "D335",
                text: "Horlogerie",
                parent: 43
            },
            {
                value: 181,
                temp_id: "D341",
                text: "Construction de véhicules automobiles",
                parent: 44
            },
            {
                value: 182,
                temp_id: "D342",
                text: "Fabrication de carrosseries et remorques",
                parent: 44
            },
            {
                value: 183,
                temp_id: "D343",
                text: "Fabrication d'équipements automobiles",
                parent: 44
            },
            {
                value: 184,
                temp_id: "D351",
                text: "Construction navale",
                parent: 45
            },
            {
                value: 185,
                temp_id: "D352",
                text: "Construction de matériel ferroviaire roulant",
                parent: 45
            },
            {
                value: 186,
                temp_id: "D353",
                text: "Construction aéronautique et spatiale",
                parent: 45
            },
            {
                value: 187,
                temp_id: "D354",
                text: "Fabrication de motocylces et de bicyclettes",
                parent: 45
            },
            {
                value: 188,
                temp_id: "D355",
                text: "Fabrication de matériels de transport n.c.a.",
                parent: 45
            },
            {
                value: 189,
                temp_id: "D361",
                text: "Fabrication de meubles",
                parent: 46
            },
            {
                value: 190,
                temp_id: "D362",
                text: "Bijouterie",
                parent: 46
            },
            {
                value: 191,
                temp_id: "D363",
                text: "Fabrication d'instruments de musique",
                parent: 46
            },
            {
                value: 192,
                temp_id: "D364",
                text: "Fabrication d'articles de sport",
                parent: 46
            },
            {
                value: 193,
                temp_id: "D365",
                text: "Fabrication de jeux et jouets",
                parent: 46
            },
            {
                value: 194,
                temp_id: "D366",
                text: "Autres industries diverses",
                parent: 46
            },
            {
                value: 195,
                temp_id: "D371",
                text: "Récupération de matières métalliques recyclables",
                parent: 47
            },
            {
                value: 196,
                temp_id: "D372",
                text: "Récupération de matières non métalliques recyclables",
                parent: 47
            },
            {
                value: 197,
                temp_id: "E401",
                text: "Production et distribution d'électricité",
                parent: 48
            },
            {
                value: 198,
                temp_id: "E402",
                text: "Production et distribution de combustibles gazeux",
                parent: 48
            },
            {
                value: 199,
                temp_id: "E403",
                text: "Production et distribution de chaleur",
                parent: 48
            },
            {
                value: 200,
                temp_id: "E410",
                text: "Captage, traitement et distribution d'eau",
                parent: 49
            },
            {
                value: 201,
                temp_id: "F451",
                text: "Préparation des sites",
                parent: 50
            },
            {
                value: 202,
                temp_id: "F452",
                text: "Construction d'ouvrages de bâtiment ou de génie-civil",
                parent: 50
            },
            {
                value: 203,
                temp_id: "F453",
                text: "Travaux d'installation",
                parent: 50
            },
            {
                value: 204,
                temp_id: "F454",
                text: "Travaux de finition",
                parent: 50
            },
            {
                value: 205,
                temp_id: "F455",
                text: "Location avec opérateur de matériel de construction",
                parent: 50
            },
            {
                value: 206,
                temp_id: "G501",
                text: "Commerce de véhicules automobiles",
                parent: 51
            },
            {
                value: 207,
                temp_id: "G502",
                text: "Entretien et réparation de véhicules automobiles",
                parent: 51
            },
            {
                value: 208,
                temp_id: "G503",
                text: "Commerce d'équipements automobiles",
                parent: 51
            },
            {
                value: 209,
                temp_id: "G504",
                text: "Commerce et réparation de motocycles",
                parent: 51
            },
            {
                value: 210,
                temp_id: "G505",
                text: "Commerce de détail de carburants",
                parent: 51
            },
            {
                value: 211,
                temp_id: "G511",
                text: "Intermédiaires du commerce de gros",
                parent: 52
            },
            {
                value: 212,
                temp_id: "G512",
                text: "Commerce de gros de produits agricoles bruts",
                parent: 52
            },
            {
                value: 213,
                temp_id: "G513",
                text: "Commerce de gros de produits alimentaires",
                parent: 52
            },
            {
                value: 214,
                temp_id: "G514",
                text:
                    "Commerce de gros de biens de consommation non alimentaires",
                parent: 52
            },
            {
                value: 215,
                temp_id: "G515",
                text:
                    "Commerce de gros de produits intermédiaires non agricoles",
                parent: 52
            },
            {
                value: 216,
                temp_id: "G516",
                text: "Commerce de gros d'équipements industriels",
                parent: 52
            },
            {
                value: 217,
                temp_id: "G517",
                text: "Autres commerces de gros",
                parent: 52
            },
            {
                value: 218,
                temp_id: "G521",
                text: "Commerce de détail en magasin non spécialisé",
                parent: 53
            },
            {
                value: 219,
                temp_id: "G522",
                text: "Commerce de détail alimentaire en magasin spécialisé",
                parent: 53
            },
            {
                value: 220,
                temp_id: "G523",
                text: "Commerce de détail de biens personnels",
                parent: 53
            },
            {
                value: 221,
                temp_id: "G524",
                text: "Commerce de détail d'articles domestiques",
                parent: 53
            },
            {
                value: 222,
                temp_id: "G525",
                text: "Commerce de détail de biens d'occasion en magasin",
                parent: 53
            },
            {
                value: 223,
                temp_id: "G526",
                text: "Commerce de détail hors magasin",
                parent: 53
            },
            {
                value: 224,
                temp_id: "G527",
                text: "Réparation d'articles personnels et domestiques",
                parent: 53
            },
            { value: 225, temp_id: "H551", text: "Hôtels", parent: 54 },
            {
                value: 226,
                temp_id: "H552",
                text: "Autres moyens d'hébergements de courte durée",
                parent: 54
            },
            {
                value: 227,
                temp_id: "H553",
                text: "Restaurants",
                parent: 54
            },
            {
                value: 228,
                temp_id: "H554",
                text: "Débits de boissons",
                parent: 54
            },
            {
                value: 229,
                temp_id: "I601",
                text: "Transports ferroviaires",
                parent: 55
            },
            {
                value: 230,
                temp_id: "I602",
                text: "Transports routiers urbains",
                parent: 55
            },
            {
                value: 231,
                temp_id: "I603",
                text: "Transports routiers interurbains",
                parent: 55
            },
            {
                value: 232,
                temp_id: "I604",
                text: "Transports touristiques",
                parent: 55
            },
            {
                value: 233,
                temp_id: "I605",
                text: "Transports routiers communaux",
                parent: 55
            },
            {
                value: 234,
                temp_id: "I606",
                text: "Transport international routier",
                parent: 55
            },
            {
                value: 235,
                temp_id: "I607",
                text: "Transport par conduite",
                parent: 55
            },
            {
                value: 236,
                temp_id: "I611",
                text: "Transports maritimes",
                parent: 56
            },
            {
                value: 237,
                temp_id: "I612",
                text: "Transports côtiers",
                parent: 56
            },
            {
                value: 238,
                temp_id: "I621",
                text: "Transport aérien régulier",
                parent: 57
            },
            {
                value: 239,
                temp_id: "I622",
                text: "Transports aériens non réguliers",
                parent: 57
            },
            {
                value: 240,
                temp_id: "I631",
                text: "Manutention et entreposage",
                parent: 58
            },
            {
                value: 241,
                temp_id: "I632",
                text: "Gestion d'infrastructures de transports",
                parent: 58
            },
            {
                value: 242,
                temp_id: "I633",
                text: "Agences de voyage",
                parent: 58
            },
            {
                value: 243,
                temp_id: "I634",
                text: "Organisation du transport de fret",
                parent: 58
            },
            {
                value: 244,
                temp_id: "I641",
                text: "Activités de poste et de courrier",
                parent: 59
            },
            {
                value: 245,
                temp_id: "I642",
                text: "Télécommunications",
                parent: 59
            },
            {
                value: 246,
                temp_id: "J651",
                text: "Intermédiation monétaire",
                parent: 60
            },
            {
                value: 247,
                temp_id: "J652",
                text: "Autres intermédiations financières",
                parent: 60
            },
            {
                value: 248,
                temp_id: "J660",
                text: "Assurance",
                parent: 61
            },
            {
                value: 249,
                temp_id: "J671",
                text: "Auxiliaires financiers",
                parent: 62
            },
            {
                value: 250,
                temp_id: "J672",
                text: "Auxiliaires d'assurance",
                parent: 62
            },
            {
                value: 251,
                temp_id: "K701",
                text: "Activités immobilières pour compte propre",
                parent: 63
            },
            {
                value: 252,
                temp_id: "K702",
                text: "Location de biens immobiliers",
                parent: 63
            },
            {
                value: 253,
                temp_id: "K703",
                text: "Activités immobilières pour compte de tiers",
                parent: 63
            },
            {
                value: 254,
                temp_id: "K711",
                text: "Location de véhicules automobiles",
                parent: 64
            },
            {
                value: 255,
                temp_id: "K712",
                text: "Location d'autres matériels de transport",
                parent: 64
            },
            {
                value: 256,
                temp_id: "K713",
                text: "Location de machines et équipements",
                parent: 64
            },
            {
                value: 257,
                temp_id: "K714",
                text: "Location de biens personnels et domestiques",
                parent: 64
            },
            {
                value: 258,
                temp_id: "K721",
                text: "Conseil en systèmes informatiques",
                parent: 65
            },
            {
                value: 259,
                temp_id: "K722",
                text: "Réalisation de logiciels",
                parent: 65
            },
            {
                value: 260,
                temp_id: "K723",
                text: "Traitement de données",
                parent: 65
            },
            {
                value: 261,
                temp_id: "K724",
                text: "Activités de banques de données.",
                parent: 65
            },
            {
                value: 262,
                temp_id: "K725",
                text:
                    "Entretien et réparation de machines de bureau et de matériel informatique",
                parent: 65
            },
            {
                value: 263,
                temp_id: "K726",
                text: "Autres activités rattachées à l'informatique",
                parent: 65
            },
            {
                value: 264,
                temp_id: "K731",
                text:
                    "Recherche-développement en sciences physiques et naturelles",
                parent: 66
            },
            {
                value: 265,
                temp_id: "K732",
                text:
                    "Recherche-développement en sciences humaines et sociales",
                parent: 66
            },
            {
                value: 266,
                temp_id: "K741",
                text:
                    "Activités juridiques, comptables et de conseil de gestion",
                parent: 67
            },
            {
                value: 267,
                temp_id: "K742",
                text: "Activités d'architecture et d'ingénierie",
                parent: 67
            },
            {
                value: 268,
                temp_id: "K743",
                text: "Activités de contrôle et analyses techniques",
                parent: 67
            },
            {
                value: 269,
                temp_id: "K744",
                text: "Publicité",
                parent: 67
            },
            {
                value: 270,
                temp_id: "K745",
                text: "Sélection et fourniture de personnel",
                parent: 67
            },
            {
                value: 271,
                temp_id: "K746",
                text: "Enquêtes et sécurité",
                parent: 67
            },
            {
                value: 272,
                temp_id: "K747",
                text: "Activités de nettoyage",
                parent: 67
            },
            {
                value: 273,
                temp_id: "K748",
                text: "Services divers fournis principalement aux entreprises",
                parent: 67
            },
            {
                value: 274,
                temp_id: "L751",
                text: "Administration générale, économique et sociale",
                parent: 68
            },
            {
                value: 275,
                temp_id: "L752",
                text: "Services de souveraineté",
                parent: 68
            },
            {
                value: 276,
                temp_id: "L753",
                text: "Sécurité sociale obligatoire",
                parent: 68
            },
            {
                value: 277,
                temp_id: "M801",
                text: "Enseignement préscolaire",
                parent: 69
            },
            {
                value: 278,
                temp_id: "M802",
                text: "Enseignement fondamental",
                parent: 69
            },
            {
                value: 279,
                temp_id: "M803",
                text: "Enseignement secondaire",
                parent: 69
            },
            {
                value: 280,
                temp_id: "M804",
                text: "Enseignement supérieur",
                parent: 69
            },
            {
                value: 281,
                temp_id: "M805",
                text: "Formation professionnelle",
                parent: 69
            },
            {
                value: 282,
                temp_id: "M806",
                text: "Formation permanente et autres activités d'enseignement",
                parent: 69
            },
            {
                value: 283,
                temp_id: "N851",
                text: "Activités pour la santé humaine",
                parent: 70
            },
            {
                value: 284,
                temp_id: "N852",
                text: "Activités vétérinaires",
                parent: 70
            },
            {
                value: 285,
                temp_id: "N853",
                text: "Action sociale",
                parent: 70
            },
            {
                value: 286,
                temp_id: "O900",
                text: "Assainissement,  voirie et gestion de déchets",
                parent: 71
            },
            {
                value: 287,
                temp_id: "O911",
                text: "Organisations économiques",
                parent: 72
            },
            {
                value: 288,
                temp_id: "O912",
                text: "Syndicats de salariés",
                parent: 72
            },
            {
                value: 289,
                temp_id: "O913",
                text: "Autres organisations associatives",
                parent: 72
            },
            {
                value: 290,
                temp_id: "O921",
                text: "Activités cinématographiques et vidéo",
                parent: 73
            },
            {
                value: 291,
                temp_id: "O922",
                text: "Activités de radio et de télévision",
                parent: 73
            },
            {
                value: 292,
                temp_id: "O923",
                text: "Autres activités de spectacle",
                parent: 73
            },
            {
                value: 293,
                temp_id: "O924",
                text: "Agence de presse",
                parent: 73
            },
            {
                value: 294,
                temp_id: "O925",
                text: "Autres activités culturelles",
                parent: 73
            },
            {
                value: 295,
                temp_id: "O926",
                text: "Activités liées au sport",
                parent: 73
            },
            {
                value: 296,
                temp_id: "O927",
                text: "Activités récréatives",
                parent: 73
            },
            {
                value: 297,
                temp_id: "O930",
                text: "Services personnels",
                parent: 74
            },
            {
                value: 298,
                temp_id: "P950",
                text: "Services domestiques",
                parent: 75
            },
            {
                value: 299,
                temp_id: "Q990",
                text: "Activités extra-territoriales",
                parent: 76
            },
            {
                value: 300,
                temp_id: "A0111",
                text: "Culture de cereales",
                parent: 77
            },
            {
                value: 301,
                temp_id: "A0112",
                text: "Culture de legumineuses",
                parent: 77
            },
            {
                value: 302,
                temp_id: "A0113",
                text: "Cultures fourrageres",
                parent: 77
            },
            {
                value: 303,
                temp_id: "A0114",
                text:
                    "Culture industrielles alimentaires (oleagineuses, sucrieres, the, etc)",
                parent: 77
            },
            {
                value: 304,
                temp_id: "A0115",
                text: "Autres cultures industrielles (coton, tabac, lin)",
                parent: 77
            },
            {
                value: 305,
                temp_id: "A0116",
                text: "Cultures maraîcheres",
                parent: 77
            },
            {
                value: 306,
                temp_id: "A0117",
                text:
                    "Cultures florales, ornementales, aromatiques et medicinales",
                parent: 77
            },
            {
                value: 307,
                temp_id: "A0121",
                text: "Oleiculture",
                parent: 78
            },
            {
                value: 308,
                temp_id: "A0122",
                text: "Agrumiculture",
                parent: 78
            },
            {
                value: 309,
                temp_id: "A0123",
                text: "Rosacees fruitieres",
                parent: 78
            },
            {
                value: 310,
                temp_id: "A0124",
                text: "Palmiers-dattiers",
                parent: 78
            },
            {
                value: 311,
                temp_id: "A0125",
                text: "Viticulture",
                parent: 78
            },
            {
                value: 312,
                temp_id: "A0126",
                text: "Cultures tropicales",
                parent: 78
            },
            {
                value: 313,
                temp_id: "A0127",
                text: "Autres plantations fruitieres",
                parent: 78
            },
            {
                value: 314,
                temp_id: "A0128",
                text: "pepinieres",
                parent: 78
            },
            {
                value: 315,
                temp_id: "A0131",
                text: "Elevage de bovins",
                parent: 79
            },
            {
                value: 316,
                temp_id: "A0132",
                text: "Elevage d'ovins et de caprins",
                parent: 79
            },
            {
                value: 317,
                temp_id: "A0133",
                text: "Elevage d'equides",
                parent: 79
            },
            {
                value: 318,
                temp_id: "A0134",
                text: "Elevage de volailles",
                parent: 79
            },
            {
                value: 319,
                temp_id: "A0135",
                text: "Elevage de camelides",
                parent: 79
            },
            {
                value: 320,
                temp_id: "A0136",
                text: "Elevage d'autres animaux",
                parent: 79
            },
            {
                value: 321,
                temp_id: "A0140",
                text: "Culture et elevage associes",
                parent: 80
            },
            {
                value: 322,
                temp_id: "A0151",
                text: "Services aux cultures productives",
                parent: 81
            },
            {
                value: 323,
                temp_id: "A0152",
                text: "Realisation et entretien de plantations ornementales",
                parent: 81
            },
            {
                value: 324,
                temp_id: "A0153",
                text: "Services annexes a l'elevage",
                parent: 81
            },
            { value: 325, temp_id: "A0160", text: "Chasse", parent: 82 },
            {
                value: 326,
                temp_id: "A0201",
                text: "Sylviculture",
                parent: 83
            },
            {
                value: 327,
                temp_id: "A0202",
                text: "Exploitation forestiere",
                parent: 83
            },
            {
                value: 328,
                temp_id: "A0203",
                text: "Recolte de l'alfa",
                parent: 83
            },
            {
                value: 329,
                temp_id: "A0204",
                text: "Recolte du liege",
                parent: 83
            },
            {
                value: 330,
                temp_id: "A0205",
                text: "Services forestiers",
                parent: 83
            },
            { value: 331, temp_id: "B0501", text: "Pêche", parent: 84 },
            {
                value: 332,
                temp_id: "B0502",
                text:
                    "Aquaculture; activites littorales de pêche; pisciculture en eau douce",
                parent: 84
            },
            {
                value: 333,
                temp_id: "C1000",
                text: "Extraction de houille, de lignite et de tourbe",
                parent: 85
            },
            {
                value: 334,
                temp_id: "C1111",
                text:
                    "Exploitation de gisements d'hydrocarbures (y compris extraction de schistes bitumineux",
                parent: 86
            },
            {
                value: 335,
                temp_id: "C1112",
                text: "Liquefaction de gaz naturel",
                parent: 86
            },
            {
                value: 336,
                temp_id: "C1121",
                text: "Forages d'hydrocarbures pour compte de tiers",
                parent: 87
            },
            {
                value: 337,
                temp_id: "C1122",
                text:
                    "Autres services annexes a l'exploitation de gisements d'hydrocarbures",
                parent: 87
            },
            {
                value: 338,
                temp_id: "C1310",
                text: "Minerais de fer",
                parent: 88
            },
            {
                value: 339,
                temp_id: "C1320",
                text: "Minerais de metaux non ferreux",
                parent: 89
            },
            {
                value: 340,
                temp_id: "C1411",
                text:
                    "Extraction de pierres pour la construction y compris ardoise",
                parent: 90
            },
            {
                value: 341,
                temp_id: "C1412",
                text: "Extraction de calcaire industriel, de gypse et de craie",
                parent: 90
            },
            {
                value: 342,
                temp_id: "C1421",
                text: "Extraction du sable marin",
                parent: 91
            },
            {
                value: 343,
                temp_id: "C1422",
                text: "Extraction de granulats",
                parent: 91
            },
            {
                value: 344,
                temp_id: "C1423",
                text: "Extraction d'argiles et de Kaolin",
                parent: 91
            },
            {
                value: 345,
                temp_id: "C1430",
                text: "Phosphates naturels",
                parent: 92
            },
            {
                value: 346,
                temp_id: "C1441",
                text: "Production de sel",
                parent: 93
            },
            {
                value: 347,
                temp_id: "C1442",
                text: "Mineraux n.c.a",
                parent: 93
            },
            {
                value: 348,
                temp_id: "D1511",
                text: "Production de viandes de boucherie",
                parent: 94
            },
            {
                value: 349,
                temp_id: "D1512",
                text: "Production de viandes de volailles",
                parent: 94
            },
            {
                value: 350,
                temp_id: "D1513",
                text: "Preparation de produits a base de viandes",
                parent: 94
            },
            {
                value: 351,
                temp_id: "D1521",
                text: "Preparation et conserve de poissons",
                parent: 95
            },
            {
                value: 352,
                temp_id: "D1522",
                text: "Autres preparations de produits de pêche",
                parent: 95
            },
            {
                value: 353,
                temp_id: "D1531",
                text: "Preparation de jus de fruits et legumes",
                parent: 96
            },
            {
                value: 354,
                temp_id: "D1532",
                text: "Transformation et conservation de tomates",
                parent: 96
            },
            {
                value: 355,
                temp_id: "D1533",
                text: "Transformation et conservation de legumes",
                parent: 96
            },
            {
                value: 356,
                temp_id: "D1534",
                text: "Transformation et conservation de fruits",
                parent: 96
            },
            {
                value: 357,
                temp_id: "D1541",
                text: "Fabrication d'huilles d'olives",
                parent: 97
            },
            {
                value: 358,
                temp_id: "D1542",
                text: "Fabrication d'huiles de graines",
                parent: 97
            },
            {
                value: 359,
                temp_id: "D1543",
                text: "Fabrication d'autres huiles",
                parent: 97
            },
            {
                value: 360,
                temp_id: "D1544",
                text: "Fabrication de margarine",
                parent: 97
            },
            {
                value: 361,
                temp_id: "D1545",
                text: "Fabrication d'autres graisses (sauf beurre)",
                parent: 97
            },
            {
                value: 362,
                temp_id: "D1551",
                text: "Traitement du lait",
                parent: 98
            },
            {
                value: 363,
                temp_id: "D1552",
                text: "Fabrication de produits laitiers",
                parent: 98
            },
            {
                value: 364,
                temp_id: "D1553",
                text: "Fabrictation de glaces et sorbets",
                parent: 98
            },
            {
                value: 365,
                temp_id: "D1561",
                text: "Meunerie  : ( y.c. meuniers des quartiers)",
                parent: 99
            },
            {
                value: 366,
                temp_id: "D1562",
                text: "Autres activites de travail des grains",
                parent: 99
            },
            {
                value: 367,
                temp_id: "D1563",
                text: "Fabrication de produits amylaces",
                parent: 99
            },
            {
                value: 368,
                temp_id: "D1564",
                text: "Fabrication d'aliments pour animaux",
                parent: 99
            },
            {
                value: 369,
                temp_id: "D1571",
                text:
                    "Boulangerie et boulangerie-pâtisserie  : (y.c les fourniers de quartiers)",
                parent: 100
            },
            {
                value: 370,
                temp_id: "D1572",
                text: "Pâtisserie (exclusive)",
                parent: 100
            },
            {
                value: 371,
                temp_id: "D1573",
                text: "Biscotterie, biscuiterie, pâtisserie de conservation",
                parent: 100
            },
            {
                value: 372,
                temp_id: "D1574",
                text: "Fabrication de pâtes alimentaires et de couscous",
                parent: 100
            },
            {
                value: 373,
                temp_id: "D1581",
                text: "Fabrication de sucre",
                parent: 101
            },
            {
                value: 374,
                temp_id: "D1582",
                text: "Chocolaterie, confiserie",
                parent: 101
            },
            {
                value: 375,
                temp_id: "D1583",
                text: "Transformation du the et du cafe",
                parent: 101
            },
            {
                value: 376,
                temp_id: "D1584",
                text: "Fabrication de condiments et assaisonnements",
                parent: 101
            },
            {
                value: 377,
                temp_id: "D1585",
                text: "Preparations alimentaires et plats cuisines",
                parent: 101
            },
            {
                value: 378,
                temp_id: "D1586",
                text: "Industries alimentaires diverses",
                parent: 101
            },
            {
                value: 379,
                temp_id: "D1591",
                text: "Production de boissons alcooliques distillees",
                parent: 102
            },
            {
                value: 380,
                temp_id: "D1592",
                text: "Production d'alcool ethylique de fermentation",
                parent: 102
            },
            {
                value: 381,
                temp_id: "D1593",
                text: "Production de vin",
                parent: 102
            },
            {
                value: 382,
                temp_id: "D1594",
                text: "Production de boissons fermentees diverses",
                parent: 102
            },
            {
                value: 383,
                temp_id: "D1595",
                text: "Brasserie et malterie",
                parent: 102
            },
            {
                value: 384,
                temp_id: "D1596",
                text: "Industrie des eaux de table",
                parent: 102
            },
            {
                value: 385,
                temp_id: "D1597",
                text: "Production de boissons rafraîchissantes",
                parent: 102
            },
            {
                value: 386,
                temp_id: "D1600",
                text: "Industrie du tabac",
                parent: 103
            },
            {
                value: 387,
                temp_id: "D1711",
                text: "Filature de l'industrie cotonniere",
                parent: 104
            },
            {
                value: 388,
                temp_id: "D1712",
                text: "Filature de l'industrie lainiere - cycle carde",
                parent: 104
            },
            {
                value: 389,
                temp_id: "D1713",
                text:
                    "Preparation et filature de l'industrie lainiere - cycle peigne",
                parent: 104
            },
            {
                value: 390,
                temp_id: "D1714",
                text:
                    "Moulinage et texturation de la soie et des textiles artificiels ou synthetiques",
                parent: 104
            },
            {
                value: 391,
                temp_id: "D1715",
                text: "Fabrication de fils a coudre",
                parent: 104
            },
            {
                value: 392,
                temp_id: "D1716",
                text:
                    "Preparation et filature de jute et d'autres fibres dures",
                parent: 104
            },
            {
                value: 393,
                temp_id: "D1721",
                text: "Tissage de l'industrie contonniere",
                parent: 105
            },
            {
                value: 394,
                temp_id: "D1722",
                text: "Tissage de l'industrie lainiere - cycle carde",
                parent: 105
            },
            {
                value: 395,
                temp_id: "D1723",
                text: "Tissage de l'industrie lainiere - cycle peigne",
                parent: 105
            },
            {
                value: 396,
                temp_id: "D1724",
                text: "Tissage de soieries",
                parent: 105
            },
            {
                value: 397,
                temp_id: "D1725",
                text: "Tissage d'autres textiles",
                parent: 105
            },
            {
                value: 398,
                temp_id: "D1730",
                text: "Ennoblissement textile",
                parent: 106
            },
            {
                value: 399,
                temp_id: "D1741",
                text: "Fabrication de couvertures (industrie)",
                parent: 107
            },
            {
                value: 400,
                temp_id: "D1742",
                text: "Fabrication de linges domestiques divers",
                parent: 107
            },
            {
                value: 401,
                temp_id: "D1743",
                text:
                    "Fabrication artisanale d'articles textiles traditionnels",
                parent: 107
            },
            {
                value: 402,
                temp_id: "D1744",
                text: "fabrication d'autres articles confectionnes en textile",
                parent: 107
            },
            {
                value: 403,
                temp_id: "D1751",
                text: "Fabrication de tapis et moquettes (industrie)",
                parent: 108
            },
            {
                value: 404,
                temp_id: "D1752",
                text: "Fabrication artisanale de tapis",
                parent: 108
            },
            {
                value: 405,
                temp_id: "D1753",
                text: "ficellerie, corderie, fabrication de filets",
                parent: 108
            },
            {
                value: 406,
                temp_id: "D1754",
                text: "Fabrication de non-tisses",
                parent: 108
            },
            {
                value: 407,
                temp_id: "D1755",
                text: "Industries textiles n.c.a.",
                parent: 108
            },
            {
                value: 408,
                temp_id: "D1760",
                text: "Fabrication d'etoffes a maille",
                parent: 109
            },
            {
                value: 409,
                temp_id: "D1771",
                text: "Fabrication d'articles chaussants a maille",
                parent: 110
            },
            {
                value: 410,
                temp_id: "D1772",
                text: "Fabrication de pull-overs et articles similaires",
                parent: 110
            },
            {
                value: 411,
                temp_id: "D1810",
                text: "Fabrication de vêtements en cuir",
                parent: 111
            },
            {
                value: 412,
                temp_id: "D1821",
                text: "Fabrication de vêtements de travail",
                parent: 112
            },
            {
                value: 413,
                temp_id: "D1822",
                text: "Fabrication de vêtements sur mesure",
                parent: 112
            },
            {
                value: 414,
                temp_id: "D1823",
                text: "Fabrication industrielle de vêtements de dessus",
                parent: 112
            },
            {
                value: 415,
                temp_id: "D1824",
                text: "Fabrication industrielle de vêtements de dessous",
                parent: 112
            },
            {
                value: 416,
                temp_id: "D1825",
                text: "Fabrication d'autres vêtements et accessoires",
                parent: 112
            },
            {
                value: 417,
                temp_id: "D1830",
                text: "Industrie des fourrures",
                parent: 113
            },
            {
                value: 418,
                temp_id: "D1910",
                text: "Apprêt et tannage des cuirs",
                parent: 114
            },
            {
                value: 419,
                temp_id: "D1920",
                text: "Fabrication d'articles de voyage et de maroquinerie",
                parent: 115
            },
            {
                value: 420,
                temp_id: "D1931",
                text: "Fabrication industrielle de chaussures modernes",
                parent: 116
            },
            {
                value: 421,
                temp_id: "D1932",
                text: "Fabrication artisanale de chaussures traditionnelles",
                parent: 116
            },
            {
                value: 422,
                temp_id: "D2010",
                text: "Sciage, rabotage, impregnation du bois",
                parent: 117
            },
            {
                value: 423,
                temp_id: "D2020",
                text: "Fabrication de panneaux de bois",
                parent: 118
            },
            {
                value: 424,
                temp_id: "D2030",
                text: "Fabrication de charpentes et de menuiseries",
                parent: 119
            },
            {
                value: 425,
                temp_id: "D2040",
                text: "Fabrication d'emballages en bois",
                parent: 120
            },
            {
                value: 426,
                temp_id: "D2051",
                text: "Fabrication d'objets divers en bois",
                parent: 121
            },
            {
                value: 427,
                temp_id: "D2052",
                text: "Fabrication d'objets en liege",
                parent: 121
            },
            {
                value: 428,
                temp_id: "D2053",
                text:
                    "Fabrication d'objets en vannerie ou sparterie (y compris la fabrication artisanale)",
                parent: 121
            },
            {
                value: 429,
                temp_id: "D2111",
                text: "Fabrication de pâte a papier",
                parent: 122
            },
            {
                value: 430,
                temp_id: "D2112",
                text: "Fabrication de papier et de carton",
                parent: 122
            },
            {
                value: 431,
                temp_id: "D2121",
                text:
                    "Fabrication de carton ondule, et d'emballages en carton ou en papier",
                parent: 123
            },
            {
                value: 432,
                temp_id: "D2122",
                text:
                    "Fabrication d'articles en papier a usage sanitaire ou domestique",
                parent: 123
            },
            {
                value: 433,
                temp_id: "D2123",
                text: "Fabrication d'articles de papeterie",
                parent: 123
            },
            {
                value: 434,
                temp_id: "D2124",
                text: "Fabrication de papiers peints",
                parent: 123
            },
            {
                value: 435,
                temp_id: "D2125",
                text: "Fabrication d'articles divers en papier ou en carton",
                parent: 123
            },
            {
                value: 436,
                temp_id: "D2211",
                text: "Edition de livres",
                parent: 124
            },
            {
                value: 437,
                temp_id: "D2212",
                text: "Edition de journaux",
                parent: 124
            },
            {
                value: 438,
                temp_id: "D2213",
                text: "Edition de revues et periodiques",
                parent: 124
            },
            {
                value: 439,
                temp_id: "D2214",
                text: "Edition d'enregistrements sonores",
                parent: 124
            },
            {
                value: 440,
                temp_id: "D2215",
                text: "Autres activites d'edition",
                parent: 124
            },
            {
                value: 441,
                temp_id: "D2221",
                text: "Imprimerie de journaux",
                parent: 125
            },
            {
                value: 442,
                temp_id: "D2222",
                text: "Autre imprimerie (labeur)",
                parent: 125
            },
            {
                value: 443,
                temp_id: "D2223",
                text: "Reliure et finition",
                parent: 125
            },
            {
                value: 444,
                temp_id: "D2224",
                text: "Composition et photogravure",
                parent: 125
            },
            {
                value: 445,
                temp_id: "D2225",
                text: "Autres activites graphiques",
                parent: 125
            },
            {
                value: 446,
                temp_id: "D2231",
                text: "Reproduction d'enregistrements sonores",
                parent: 126
            },
            {
                value: 447,
                temp_id: "D2232",
                text: "Reproduction d'enregistrements video",
                parent: 126
            },
            {
                value: 448,
                temp_id: "D2233",
                text: "Reproduction d'enregistrements informatiques",
                parent: 126
            },
            {
                value: 449,
                temp_id: "D2310",
                text: "Cokefaction",
                parent: 127
            },
            {
                value: 450,
                temp_id: "D2320",
                text: "Raffinage de petrole",
                parent: 128
            },
            {
                value: 451,
                temp_id: "D2330",
                text: "Elaboration et transformation de matieres nucleaires",
                parent: 129
            },
            {
                value: 452,
                temp_id: "D2411",
                text: "Fabrication de gaz industriels",
                parent: 130
            },
            {
                value: 453,
                temp_id: "D2412",
                text: "Fabrication de colorants et de pigments",
                parent: 130
            },
            {
                value: 454,
                temp_id: "D2413",
                text:
                    "Fabrication d'autres produits chimiques inorganiques de base",
                parent: 130
            },
            {
                value: 455,
                temp_id: "D2414",
                text:
                    "Fabrication d'autres produits chimiques inorganiques de base",
                parent: 130
            },
            {
                value: 456,
                temp_id: "D2415",
                text: "Fabrication de produits azotes et d'engrais",
                parent: 130
            },
            {
                value: 457,
                temp_id: "D2416",
                text: "Fabrication de matieres plastiques de base",
                parent: 130
            },
            {
                value: 458,
                temp_id: "D2417",
                text: "Fabrication de caoutchouc synthetique",
                parent: 130
            },
            {
                value: 459,
                temp_id: "D2420",
                text: "Fabrication de produits agrochimiques",
                parent: 131
            },
            {
                value: 460,
                temp_id: "D2430",
                text: "Fabrication de peintures et vernis",
                parent: 132
            },
            {
                value: 461,
                temp_id: "D2441",
                text: "Fabrication de produits pharmaceutiques de base",
                parent: 133
            },
            {
                value: 462,
                temp_id: "D2442",
                text: "Fabrication et preparations des produits a usage humain",
                parent: 133
            },
            {
                value: 463,
                temp_id: "D2443",
                text:
                    "Fabrication et preparations des produits a usage veterinaire",
                parent: 133
            },
            {
                value: 464,
                temp_id: "D2451",
                text:
                    "Fabrication de savons, detergents et produits d'entretien",
                parent: 134
            },
            {
                value: 465,
                temp_id: "D2452",
                text: "Fabrication de parfums et de produits pour la toilette",
                parent: 134
            },
            {
                value: 466,
                temp_id: "D2461",
                text: "Fabrication de produits explosifs",
                parent: 135
            },
            {
                value: 467,
                temp_id: "D2462",
                text: "Fabrication de colles et gelatines",
                parent: 135
            },
            {
                value: 468,
                temp_id: "D2463",
                text: "Fabrication d'huiles essentielles",
                parent: 135
            },
            {
                value: 469,
                temp_id: "D2464",
                text: "Fabrication de produits chimiques pour la photographie",
                parent: 135
            },
            {
                value: 470,
                temp_id: "D2465",
                text: "Fabrication de supports de donnees",
                parent: 135
            },
            {
                value: 471,
                temp_id: "D2466",
                text: "Fabrication de produits chimiques a usage industriel",
                parent: 135
            },
            {
                value: 472,
                temp_id: "D2470",
                text: "Fabrication de fibres artificielles ou synthetiques",
                parent: 136
            },
            {
                value: 473,
                temp_id: "D2511",
                text: "Fabrication de pneumatiques",
                parent: 137
            },
            {
                value: 474,
                temp_id: "D2512",
                text: "Rechapage de pneumatiques",
                parent: 137
            },
            {
                value: 475,
                temp_id: "D2513",
                text: "Fabrication d'autres articles en caoutchouc",
                parent: 137
            },
            {
                value: 476,
                temp_id: "D2521",
                text:
                    "Fabrication de plaques, feuilles, tubes et profiles en matieres plastiques",
                parent: 138
            },
            {
                value: 477,
                temp_id: "D2522",
                text: "Fabrication d'emballages en matieres plastiques",
                parent: 138
            },
            {
                value: 478,
                temp_id: "D2523",
                text:
                    "Fabrication d'elements en matieres plastiques pour la construction",
                parent: 138
            },
            {
                value: 479,
                temp_id: "D2524",
                text: "Fabrication d'autres articles en matieres plastiques",
                parent: 138
            },
            {
                value: 480,
                temp_id: "D2611",
                text: "Fabrication de verre plat",
                parent: 139
            },
            {
                value: 481,
                temp_id: "D2612",
                text: "Façonnage et transformation du verre plat",
                parent: 139
            },
            {
                value: 482,
                temp_id: "D2613",
                text: "Fabrication de verre creux",
                parent: 139
            },
            {
                value: 483,
                temp_id: "D2614",
                text: "Fabrication de fibres de verre",
                parent: 139
            },
            {
                value: 484,
                temp_id: "D2615",
                text: "Fabrication et façonnage d'autres articles en verre",
                parent: 139
            },
            {
                value: 485,
                temp_id: "D2621",
                text:
                    "Fabrication d'articles ceramiques a usage domestique ou ornemental",
                parent: 140
            },
            {
                value: 486,
                temp_id: "D2622",
                text: "Fabrication d'appareils sanitaires en ceramique",
                parent: 140
            },
            {
                value: 487,
                temp_id: "D2623",
                text:
                    "Fabrication d'autres produits ceramiques non refractaires",
                parent: 140
            },
            {
                value: 488,
                temp_id: "D2624",
                text: "Fabrication de produits ceramiques refractaires",
                parent: 140
            },
            {
                value: 489,
                temp_id: "D2630",
                text: "Fabrication de carreaux en ceramique",
                parent: 141
            },
            {
                value: 490,
                temp_id: "D2640",
                text: "Fabrication de tuiles et briques en terre cuite",
                parent: 142
            },
            {
                value: 491,
                temp_id: "D2651",
                text: "Fabrication de ciment",
                parent: 143
            },
            {
                value: 492,
                temp_id: "D2652",
                text: "Fabrication de chaux",
                parent: 143
            },
            {
                value: 493,
                temp_id: "D2653",
                text: "Fabrication de plâtre",
                parent: 143
            },
            {
                value: 494,
                temp_id: "D2661",
                text: "Fabrication d'elements en beton pour la construction",
                parent: 144
            },
            {
                value: 495,
                temp_id: "D2662",
                text: "Fabrication d'elements en plâtre pour la construction",
                parent: 144
            },
            {
                value: 496,
                temp_id: "D2663",
                text: "Fabrication de beton prêt a l'emploi",
                parent: 144
            },
            {
                value: 497,
                temp_id: "D2664",
                text: "Fabrication de mortiers et betons secs",
                parent: 144
            },
            {
                value: 498,
                temp_id: "D2665",
                text: "Fabrication d'ouvrages en fibre-ciments",
                parent: 144
            },
            {
                value: 499,
                temp_id: "D2666",
                text: "Fabrication d'autres ouvrages en beton ou en plâtre",
                parent: 144
            },
            {
                value: 500,
                temp_id: "D2670",
                text: "Travail de la pierre",
                parent: 145
            },
            {
                value: 501,
                temp_id: "D2681",
                text: "Fabrication de produits abrasifs",
                parent: 146
            },
            {
                value: 502,
                temp_id: "D2682",
                text: "Fabrication de produits mineraux non metalliques n.c.a.",
                parent: 146
            },
            {
                value: 503,
                temp_id: "D2710",
                text: "Siderurgie et production de ferro-alliages",
                parent: 147
            },
            {
                value: 504,
                temp_id: "D2721",
                text: "Fabrication de tubes en fonte",
                parent: 148
            },
            {
                value: 505,
                temp_id: "D2722",
                text: "Fabrication de tubes en acier",
                parent: 148
            },
            {
                value: 506,
                temp_id: "D2731",
                text: "Etirage a froid",
                parent: 149
            },
            {
                value: 507,
                temp_id: "D2732",
                text: "Laminage a froid de feuillards",
                parent: 149
            },
            {
                value: 508,
                temp_id: "D2733",
                text: "Profilage a froid par formage ou pilage",
                parent: 149
            },
            {
                value: 509,
                temp_id: "D2734",
                text: "Trefilage a froid",
                parent: 149
            },
            {
                value: 510,
                temp_id: "D2741",
                text: "Production de metaux precieux",
                parent: 150
            },
            {
                value: 511,
                temp_id: "D2742",
                text: "Metallurgie de l'aluminium",
                parent: 150
            },
            {
                value: 512,
                temp_id: "D2743",
                text: "Metallurgie du plomb, du zinc ou de l'etain",
                parent: 150
            },
            {
                value: 513,
                temp_id: "D2744",
                text: "Metallurgie du cuivre",
                parent: 150
            },
            {
                value: 514,
                temp_id: "D2745",
                text: "Metallurgie des autres metaux non ferreux",
                parent: 150
            },
            {
                value: 515,
                temp_id: "D2751",
                text: "Fonderie de metaux ferreux",
                parent: 151
            },
            {
                value: 516,
                temp_id: "D2752",
                text: "Fonderie de metaux non ferreux",
                parent: 151
            },
            {
                value: 517,
                temp_id: "D2811",
                text: "Fabrication de constructions metalliques",
                parent: 152
            },
            {
                value: 518,
                temp_id: "D2812",
                text: "Fabrication de menuiseries et fermetures metalliques",
                parent: 152
            },
            {
                value: 519,
                temp_id: "D2821",
                text: "Fabrication de reservoirs et citernes metalliques",
                parent: 153
            },
            {
                value: 520,
                temp_id: "D2822",
                text: "Fabrication de bouteilles pour gaz comprimes",
                parent: 153
            },
            {
                value: 521,
                temp_id: "D2823",
                text:
                    "Fabrication de radiateurs et de chaudieres pour le chauffage central",
                parent: 153
            },
            {
                value: 522,
                temp_id: "D2830",
                text: "Chaudronnerie",
                parent: 154
            },
            {
                value: 523,
                temp_id: "D2840",
                text: "Forge, emboutissage, estampage; metallurgie des poudres",
                parent: 155
            },
            {
                value: 524,
                temp_id: "D2851",
                text: "Traitement et revêtement des metaux",
                parent: 156
            },
            {
                value: 525,
                temp_id: "D2852",
                text: "Operations de mecanique generale",
                parent: 156
            },
            {
                value: 526,
                temp_id: "D2861",
                text: "Fabrication de coutellerie",
                parent: 157
            },
            {
                value: 527,
                temp_id: "D2862",
                text: "Fabrication d'outillage a main",
                parent: 157
            },
            {
                value: 528,
                temp_id: "D2863",
                text: "Fabrication d'outillage mecanique",
                parent: 157
            },
            {
                value: 529,
                temp_id: "D2864",
                text: "Fabrication de serrures et de ferrures",
                parent: 157
            },
            {
                value: 530,
                temp_id: "D2871",
                text:
                    "Fabrication de fûts et emballages metalliques similaires",
                parent: 158
            },
            {
                value: 531,
                temp_id: "D2872",
                text: "Fabrication d'emballages metalliques legers",
                parent: 158
            },
            {
                value: 532,
                temp_id: "D2873",
                text: "Fabrication d'articles en fils metalliques",
                parent: 158
            },
            {
                value: 533,
                temp_id: "D2874",
                text:
                    "Visserie et boulonnerie; fabrication de chaînes et de ressorts",
                parent: 158
            },
            {
                value: 534,
                temp_id: "D2875",
                text: "Fabrication d'articles metalliques divers",
                parent: 158
            },
            {
                value: 535,
                temp_id: "D2876",
                text:
                    "Fabrication artisanale d'ouvrages traditionnels en metaux",
                parent: 158
            },
            {
                value: 536,
                temp_id: "D2911",
                text: "Fabrication de moteurs et turbines",
                parent: 159
            },
            {
                value: 537,
                temp_id: "D2912",
                text:
                    "Fabrication de pompes, compresseurs et systemes hydrauliques",
                parent: 159
            },
            {
                value: 538,
                temp_id: "D2913",
                text: "Fabrication d'articles de robinetterie",
                parent: 159
            },
            {
                value: 539,
                temp_id: "D2914",
                text:
                    "Fabrication d'engrenages et d'oranges mecaniques de transmission",
                parent: 159
            },
            {
                value: 540,
                temp_id: "D2921",
                text: "Fabrication de fours et brûleurs",
                parent: 160
            },
            {
                value: 541,
                temp_id: "D2922",
                text: "Fabrication de materiel de levage et de manutention",
                parent: 160
            },
            {
                value: 542,
                temp_id: "D2923",
                text:
                    "Fabrication d'equipements aerauliques et frigorifiques industriels",
                parent: 160
            },
            {
                value: 543,
                temp_id: "D2924",
                text: "Fabrication d'autres machines d'usage general",
                parent: 160
            },
            {
                value: 544,
                temp_id: "D2931",
                text: "Fabrication de tracteurs agricoles",
                parent: 161
            },
            {
                value: 545,
                temp_id: "D2932",
                text: "Fabrication de materiel agricole",
                parent: 161
            },
            {
                value: 546,
                temp_id: "D2933",
                text: "Reparation de materiel agricole",
                parent: 161
            },
            {
                value: 547,
                temp_id: "D2941",
                text: "Fabrication de machines-outils a metal ou a bois",
                parent: 162
            },
            {
                value: 548,
                temp_id: "D2942",
                text:
                    "Fabrication de machines-outils portatives a moteur incorpore",
                parent: 162
            },
            {
                value: 549,
                temp_id: "D2943",
                text: "Fabrication de materiel de soudage",
                parent: 162
            },
            {
                value: 550,
                temp_id: "D2951",
                text: "Fabrication de machines pour la metallurgie",
                parent: 163
            },
            {
                value: 551,
                temp_id: "D2952",
                text:
                    "Fabrication de machines pour l'extraction ou la construction",
                parent: 163
            },
            {
                value: 552,
                temp_id: "D2953",
                text:
                    "Fabrication de machines pour l'industrie agro-alimentaire",
                parent: 163
            },
            {
                value: 553,
                temp_id: "D2954",
                text: "Fabrication de machines pour les industries textiles",
                parent: 163
            },
            {
                value: 554,
                temp_id: "D2955",
                text:
                    "Fabrication de machines pour les industries du papier et du carton",
                parent: 163
            },
            {
                value: 555,
                temp_id: "D2956",
                text: "Fabrication de machines diverses d'usage specifique",
                parent: 163
            },
            {
                value: 556,
                temp_id: "D2960",
                text: "Fabrication d'armes et de munitions",
                parent: 164
            },
            {
                value: 557,
                temp_id: "D2970",
                text: "Fabrication d'appareils domestiques",
                parent: 165
            },
            {
                value: 558,
                temp_id: "D3001",
                text: "Fabrication de machines de bureau",
                parent: 166
            },
            {
                value: 559,
                temp_id: "D3002",
                text:
                    "Fabrication d'ordinateurs et d'autres equipements informatiques",
                parent: 166
            },
            {
                value: 560,
                temp_id: "D3111",
                text: "Fabrication de machines et transformateurs electriques",
                parent: 167
            },
            {
                value: 561,
                temp_id: "D3112",
                text: "Reparation de materiels electriques",
                parent: 167
            },
            {
                value: 562,
                temp_id: "D3120",
                text:
                    "Fabrication de materiel de distribution et de commande electrique",
                parent: 168
            },
            {
                value: 563,
                temp_id: "D3130",
                text: "Fabrication de fils et câbles isoles",
                parent: 169
            },
            {
                value: 564,
                temp_id: "D3140",
                text: "Fabrication d'accumulateurs et de piles electriques",
                parent: 170
            },
            {
                value: 565,
                temp_id: "D3151",
                text: "Fabrication de lampes",
                parent: 171
            },
            {
                value: 566,
                temp_id: "D3152",
                text: "Fabrication d'appareils d'eclairage",
                parent: 171
            },
            {
                value: 567,
                temp_id: "D3161",
                text:
                    "Fabrication de materiels electriques pour moteurs et vehicules",
                parent: 172
            },
            {
                value: 568,
                temp_id: "D3162",
                text: "Fabrication de materiels electriques divers",
                parent: 172
            },
            {
                value: 569,
                temp_id: "D3210",
                text: "Fabrication de composants electroniques",
                parent: 173
            },
            {
                value: 570,
                temp_id: "D3221",
                text:
                    "Fabrication d'equipements d'emission et de transmission hertzienne",
                parent: 174
            },
            {
                value: 571,
                temp_id: "D3222",
                text: "Fabrication d'appareils de telephonie",
                parent: 174
            },
            {
                value: 572,
                temp_id: "D3230",
                text:
                    "Fabrication d'appareils de reception, enregistrement ou reproduction du son et de l'image",
                parent: 175
            },
            {
                value: 573,
                temp_id: "D3310",
                text:
                    "Fabrication de materiel medico-chirurgical et d'orthopedie",
                parent: 176
            },
            {
                value: 574,
                temp_id: "D3320",
                text: "Fabrication d'instruments de mesure et de contrôle",
                parent: 177
            },
            {
                value: 575,
                temp_id: "D3330",
                text:
                    "Fabrication d'equipements de contrôle des processus industriels",
                parent: 178
            },
            {
                value: 576,
                temp_id: "D3341",
                text: "Fabrication de lunettes",
                parent: 179
            },
            {
                value: 577,
                temp_id: "D3342",
                text:
                    "Fabrication d'instruments d'optique et de materiel photographique",
                parent: 179
            },
            {
                value: 578,
                temp_id: "D3350",
                text: "Horlogerie",
                parent: 180
            },
            {
                value: 579,
                temp_id: "D3410",
                text: "Construction de vehicules automobiles",
                parent: 181
            },
            {
                value: 580,
                temp_id: "D3420",
                text: "Fabrication de carrosseries et remorques",
                parent: 182
            },
            {
                value: 581,
                temp_id: "D3430",
                text: "Fabrication d'equipements automobiles",
                parent: 183
            },
            {
                value: 582,
                temp_id: "D3511",
                text: "Construction de navires",
                parent: 184
            },
            {
                value: 583,
                temp_id: "D3512",
                text: "Reparation navale",
                parent: 184
            },
            {
                value: 584,
                temp_id: "D3513",
                text: "Construction de bateaux de plaisance",
                parent: 184
            },
            {
                value: 585,
                temp_id: "D3520",
                text: "Construction de materiel  ferroviaire roulant",
                parent: 185
            },
            {
                value: 586,
                temp_id: "D3530",
                text: "Construction aeronautique et spatiale",
                parent: 186
            },
            {
                value: 587,
                temp_id: "D3541",
                text: "Fabrication de motocycles",
                parent: 187
            },
            {
                value: 588,
                temp_id: "D3542",
                text: "Fabrication de bicyclettes",
                parent: 187
            },
            {
                value: 589,
                temp_id: "D3543",
                text: "Fabrication de vehicules pour invalides",
                parent: 187
            },
            {
                value: 590,
                temp_id: "D3550",
                text: "Fabrication de materiels de transport n.c.a.",
                parent: 188
            },
            {
                value: 591,
                temp_id: "D3611",
                text: "Fabrication de meubles divers",
                parent: 189
            },
            {
                value: 592,
                temp_id: "D3612",
                text: "Industries connexes de l'ameublement",
                parent: 189
            },
            {
                value: 593,
                temp_id: "D3613",
                text: "Fabrication de matelas",
                parent: 189
            },
            {
                value: 594,
                temp_id: "D3621",
                text: "Bijouterie",
                parent: 190
            },
            {
                value: 595,
                temp_id: "D3622",
                text: "Fabrication de monnaies et medailles",
                parent: 190
            },
            {
                value: 596,
                temp_id: "D3630",
                text: "Fabrication d'instruments de musique",
                parent: 191
            },
            {
                value: 597,
                temp_id: "D3640",
                text: "Fabrication d'articles de sport",
                parent: 192
            },
            {
                value: 598,
                temp_id: "D3650",
                text: "Fabrication de jeux et jouets",
                parent: 193
            },
            {
                value: 599,
                temp_id: "D3661",
                text: "Bijouterie fantaisie",
                parent: 194
            },
            {
                value: 600,
                temp_id: "D3662",
                text: "Industrie de la brosserie",
                parent: 194
            },
            {
                value: 601,
                temp_id: "D3663",
                text: "Autres activites manufacturieres n.c.a.",
                parent: 194
            },
            {
                value: 602,
                temp_id: "D3710",
                text: "Recuperation de matieres metalliques recyclables",
                parent: 195
            },
            {
                value: 603,
                temp_id: "D3720",
                text: "Recuperation de matieres non metalliques recyclables",
                parent: 196
            },
            {
                value: 604,
                temp_id: "E4010",
                text: "Production et distribution d'electricite",
                parent: 197
            },
            {
                value: 605,
                temp_id: "E4020",
                text: "Production et distribution de combustibles gazeux",
                parent: 198
            },
            {
                value: 606,
                temp_id: "E4030",
                text: "Production et distribution de chaleur",
                parent: 199
            },
            {
                value: 607,
                temp_id: "E4101",
                text: "Captage",
                parent: 200
            },
            {
                value: 608,
                temp_id: "E4102",
                text: "Distribution d'eau",
                parent: 200
            },
            {
                value: 609,
                temp_id: "F4511",
                text: "Demolition et terrassements",
                parent: 201
            },
            {
                value: 610,
                temp_id: "F4512",
                text: "Forages et sondages (N.C forages petroliers)",
                parent: 201
            },
            {
                value: 611,
                temp_id: "F4521",
                text: "Construction du gros oeuvre de bâtiments",
                parent: 202
            },
            {
                value: 612,
                temp_id: "F4522",
                text: "Construction d'ouvrages d'art et de tunnels",
                parent: 202
            },
            {
                value: 613,
                temp_id: "F4523",
                text: "Realisation de reseaux (eau, eau usee, gaz)",
                parent: 202
            },
            {
                value: 614,
                temp_id: "F4524",
                text:
                    "Construction de lignes electriques et de telecommunications",
                parent: 202
            },
            {
                value: 615,
                temp_id: "F4525",
                text: "Construction de voies ferrees",
                parent: 202
            },
            {
                value: 616,
                temp_id: "F4526",
                text: "Construction de chaussees routieres et de sols sportifs",
                parent: 202
            },
            {
                value: 617,
                temp_id: "F4527",
                text: "Travaux maritimes",
                parent: 202
            },
            {
                value: 618,
                temp_id: "F4528",
                text: "Travaux  hydrauliques",
                parent: 202
            },
            {
                value: 619,
                temp_id: "F4529",
                text: "Autres travaux de construction",
                parent: 202
            },
            {
                value: 620,
                temp_id: "F4531",
                text: "Travaux d'installation electrique",
                parent: 203
            },
            {
                value: 621,
                temp_id: "F4532",
                text: "Plomberie (Eau et Gaz)",
                parent: 203
            },
            {
                value: 622,
                temp_id: "F4533",
                text:
                    "Installation d'equipements thermiques et de climatisation",
                parent: 203
            },
            {
                value: 623,
                temp_id: "F4534",
                text: "Travaux d'installation divers",
                parent: 203
            },
            {
                value: 624,
                temp_id: "F4541",
                text: "Plâtrerie",
                parent: 204
            },
            {
                value: 625,
                temp_id: "F4542",
                text: "Menuiserie bois et matieres plastiques",
                parent: 204
            },
            {
                value: 626,
                temp_id: "F4543",
                text: "Menuiserie metallique ; serrurerie",
                parent: 204
            },
            {
                value: 627,
                temp_id: "F4544",
                text: "Revêtements des sols et des murs",
                parent: 204
            },
            {
                value: 628,
                temp_id: "F4545",
                text: "Miroiterie de bâtiment, vitrerie",
                parent: 204
            },
            {
                value: 629,
                temp_id: "F4546",
                text: "Peinture",
                parent: 204
            },
            {
                value: 630,
                temp_id: "F4547",
                text: "Autres travaux de finition",
                parent: 204
            },
            {
                value: 631,
                temp_id: "F4550",
                text: "Location avec operateur de materiel de construction",
                parent: 205
            },
            {
                value: 632,
                temp_id: "G5010",
                text: "Commerce de vehicules automobiles",
                parent: 206
            },
            {
                value: 633,
                temp_id: "G5020",
                text: "Entretien et reparation de vehicules automobiles",
                parent: 207
            },
            {
                value: 634,
                temp_id: "G5030",
                text: "Commerce d'equipements automobiles",
                parent: 208
            },
            {
                value: 635,
                temp_id: "G5040",
                text: "Commerce et reparation de motocycles",
                parent: 209
            },
            {
                value: 636,
                temp_id: "G5050",
                text: "Commerce de detail de carburants",
                parent: 210
            },
            {
                value: 637,
                temp_id: "G5110",
                text: "Intermediaires du commerce de gros",
                parent: 211
            },
            {
                value: 638,
                temp_id: "G5121",
                text: "Commerce de gros de cereales et aliments pour le betail",
                parent: 212
            },
            {
                value: 639,
                temp_id: "G5122",
                text: "Commerce de gros de fleurs et plantes",
                parent: 212
            },
            {
                value: 640,
                temp_id: "G5123",
                text: "Commerce de gros d'animaux vivants",
                parent: 212
            },
            {
                value: 641,
                temp_id: "G5124",
                text: "Commerce de gros de cuirs et peaux",
                parent: 212
            },
            {
                value: 642,
                temp_id: "G5125",
                text: "Commerce de gros de tabac non manufacture",
                parent: 212
            },
            {
                value: 643,
                temp_id: "G5131",
                text: "Commerce de gros de fruits et legumes",
                parent: 213
            },
            {
                value: 644,
                temp_id: "G5132",
                text: "Commerce de gros de viandes",
                parent: 213
            },
            {
                value: 645,
                temp_id: "G5133",
                text: "Commerce de gros de produits laitiers, oeufs, huiles",
                parent: 213
            },
            {
                value: 646,
                temp_id: "G5134",
                text: "Commerce de gros de boissons",
                parent: 213
            },
            {
                value: 647,
                temp_id: "G5135",
                text: "Commerce de gros de tabac",
                parent: 213
            },
            {
                value: 648,
                temp_id: "G5136",
                text:
                    "Commerce de gros de sucre, cacao, chocolat, confiserie, cafe, the et epices",
                parent: 213
            },
            {
                value: 649,
                temp_id: "G5137",
                text: "Commerce de gros de poissons, crustaces et mollusques",
                parent: 213
            },
            {
                value: 650,
                temp_id: "G5138",
                text: "Commerce de gros alimentaires specialises divers",
                parent: 213
            },
            {
                value: 651,
                temp_id: "G5139",
                text: "Commerce de gros non specialise de denrees",
                parent: 213
            },
            {
                value: 652,
                temp_id: "G5141",
                text: "Commerce de gros de textiles",
                parent: 214
            },
            {
                value: 653,
                temp_id: "G5142",
                text: "Commerce de gros d'habillement",
                parent: 214
            },
            {
                value: 654,
                temp_id: "G5143",
                text: "Commerce de gros de la chaussure",
                parent: 214
            },
            {
                value: 655,
                temp_id: "G5144",
                text:
                    "Commerce de gros d'appareils electromenagers et de radiotelevision",
                parent: 214
            },
            {
                value: 656,
                temp_id: "G5145",
                text:
                    "Commerce de gros de ceramique, verrerie et produits d'entretien",
                parent: 214
            },
            {
                value: 657,
                temp_id: "G5146",
                text: "Commerce de gros de parfumerie et de produits de beaute",
                parent: 214
            },
            {
                value: 658,
                temp_id: "G5147",
                text: "Commerce de gros de produits pharmaceutiques",
                parent: 214
            },
            {
                value: 659,
                temp_id: "G5148",
                text:
                    "Commerce de gros de biens de consommation non alimentaires diverses",
                parent: 214
            },
            {
                value: 660,
                temp_id: "G5151",
                text: "Commerce de gros de combustibles",
                parent: 215
            },
            {
                value: 661,
                temp_id: "G5152",
                text: "Commerce de gros de minerais et metaux",
                parent: 215
            },
            {
                value: 662,
                temp_id: "G5153",
                text: "Commerce de gros de bois et de produits derives",
                parent: 215
            },
            {
                value: 663,
                temp_id: "G5154",
                text:
                    "Commerce de gros de materiaux de construction et d'appareils sanitaires",
                parent: 215
            },
            {
                value: 664,
                temp_id: "G5155",
                text:
                    "Commerce de gros de quincaillerie et fournitures pour plomberie et chauffage",
                parent: 215
            },
            {
                value: 665,
                temp_id: "G5156",
                text: "Commerce de gros de produits chimiques",
                parent: 215
            },
            {
                value: 666,
                temp_id: "G5157",
                text: "Commerce de gros d'autres produits intermediaires",
                parent: 215
            },
            {
                value: 667,
                temp_id: "G5161",
                text: "Commerce de gros de machines-outils",
                parent: 216
            },
            {
                value: 668,
                temp_id: "G5162",
                text: "Commerce de gros d'equipements pour la construction",
                parent: 216
            },
            {
                value: 669,
                temp_id: "G5163",
                text:
                    "Commerce de gros de machines pour l'industrie textile et l'habillement",
                parent: 216
            },
            {
                value: 670,
                temp_id: "G5164",
                text:
                    "Commerce de gros de machines de bureau et de materiel informatique",
                parent: 216
            },
            {
                value: 671,
                temp_id: "G5165",
                text: "Commerce de gros de materiel electrique et electronique",
                parent: 216
            },
            {
                value: 672,
                temp_id: "G5166",
                text:
                    "Commerce de gros de fournitures et equipements industriels divers",
                parent: 216
            },
            {
                value: 673,
                temp_id: "G5167",
                text: "Commerce de gros de materiel agricole",
                parent: 216
            },
            {
                value: 674,
                temp_id: "G5170",
                text: "Autres commerces de gros",
                parent: 217
            },
            {
                value: 675,
                temp_id: "G5211",
                text: "Commerce d'alimentation generale",
                parent: 218
            },
            {
                value: 676,
                temp_id: "G5212",
                text: "Superettes, supermaches et hypermarches",
                parent: 218
            },
            {
                value: 677,
                temp_id: "G5213",
                text:
                    "Autres commerces de detail en magasin non specialise a predominance alimentaire",
                parent: 218
            },
            {
                value: 678,
                temp_id: "G5214",
                text: "Commerce de detail en produits divers de l'artisanat",
                parent: 218
            },
            {
                value: 679,
                temp_id: "G5215",
                text:
                    "Commerce de detail en magasin non specialise sans predominance alimentaire",
                parent: 218
            },
            {
                value: 680,
                temp_id: "G5221",
                text: "Commerce de detail de fruits et legumes",
                parent: 219
            },
            {
                value: 681,
                temp_id: "G5222",
                text:
                    "Commerce de detail de viandes et produits a base de viande",
                parent: 219
            },
            {
                value: 682,
                temp_id: "G5223",
                text: "Commerce de detail de poissons, crustaces et mollusques",
                parent: 219
            },
            {
                value: 683,
                temp_id: "G5224",
                text: "Commerce de detail de pain, pâtisserie et confiserie",
                parent: 219
            },
            {
                value: 684,
                temp_id: "G5225",
                text: "Commerce de detail de boissons",
                parent: 219
            },
            {
                value: 685,
                temp_id: "G5226",
                text: "Commerce de detail de tabac",
                parent: 219
            },
            {
                value: 686,
                temp_id: "G5227",
                text: "Commerce de detail de produits laitiers",
                parent: 219
            },
            {
                value: 687,
                temp_id: "G5228",
                text:
                    "Commerce de detail de grains, legumes secs et produits d'epicerie",
                parent: 219
            },
            {
                value: 688,
                temp_id: "G5231",
                text: "Commerce de detail de produits pharmaceutiques",
                parent: 220
            },
            {
                value: 689,
                temp_id: "G5232",
                text: "Commerce de detail d'articles medicaux et orthopediques",
                parent: 220
            },
            {
                value: 690,
                temp_id: "G5233",
                text:
                    "Commerce de detail de parfumerie et de produits de beaute",
                parent: 220
            },
            {
                value: 691,
                temp_id: "G5234",
                text: "Commerce de detail de textiles",
                parent: 220
            },
            {
                value: 692,
                temp_id: "G5235",
                text: "Commerce de detail d'habillement",
                parent: 220
            },
            {
                value: 693,
                temp_id: "G5236",
                text: "Commerce de detail de la chaussure",
                parent: 220
            },
            {
                value: 694,
                temp_id: "G5237",
                text:
                    "Commerce de detail de maroquinerie et d'articles de voyage",
                parent: 220
            },
            {
                value: 695,
                temp_id: "G5241",
                text: "Commerce de detail de meubles et d'equipements du foyer",
                parent: 221
            },
            {
                value: 696,
                temp_id: "G5242",
                text:
                    "Commerce de detail d'appareils electromenagers et de radio television",
                parent: 221
            },
            {
                value: 697,
                temp_id: "G5243",
                text: "Commerce de detail de quincaillerie, peinture et verres",
                parent: 221
            },
            {
                value: 698,
                temp_id: "G5244",
                text: "Commerce de detail de livres, journaux et papeterie",
                parent: 221
            },
            {
                value: 699,
                temp_id: "G5245",
                text: "Commerce de detail d'optique et de photographie",
                parent: 221
            },
            {
                value: 700,
                temp_id: "G5246",
                text: "Commerce de detail d'horlogerie et de bijouterie",
                parent: 221
            },
            {
                value: 701,
                temp_id: "G5247",
                text: "Commerce de detail de fleurs et de plantes",
                parent: 221
            },
            {
                value: 702,
                temp_id: "G5248",
                text: "Commerce de detail de charbons et combustibles",
                parent: 221
            },
            {
                value: 703,
                temp_id: "G5249",
                text: "Commerce de detail divers en magasin specialise",
                parent: 221
            },
            {
                value: 704,
                temp_id: "G5250",
                text: "Commerce de detail de biens d'occasion en magasin",
                parent: 222
            },
            {
                value: 705,
                temp_id: "G5261",
                text: "Vente par correspondance",
                parent: 223
            },
            {
                value: 706,
                temp_id: "G5262",
                text: "Commerce ambulant de viandes et d'animaux vivants",
                parent: 223
            },
            {
                value: 707,
                temp_id: "G5263",
                text: "Commerce ambulant de fruits et legumes",
                parent: 223
            },
            {
                value: 708,
                temp_id: "G5264",
                text:
                    "Commerce ambulant de grains, legumes secs et produits d'epicerie",
                parent: 223
            },
            {
                value: 709,
                temp_id: "G5265",
                text: "Commerce ambulant de textiles, habillement et cuirs",
                parent: 223
            },
            {
                value: 710,
                temp_id: "G5266",
                text:
                    "Commerce ambulant de quincaillerie et d'equipement menager",
                parent: 223
            },
            {
                value: 711,
                temp_id: "G5267",
                text: "Autres commerces de detail hors magasin",
                parent: 223
            },
            {
                value: 712,
                temp_id: "G5271",
                text: "Reparation de chaussures et d'articles en cuir",
                parent: 224
            },
            {
                value: 713,
                temp_id: "G5272",
                text: "Reparation de materiel electronique grand public",
                parent: 224
            },
            {
                value: 714,
                temp_id: "G5273",
                text: "Reparation d'appareils electromenagers",
                parent: 224
            },
            {
                value: 715,
                temp_id: "G5274",
                text: "Reparation de montres, horloges et bijoux",
                parent: 224
            },
            {
                value: 716,
                temp_id: "G5275",
                text: "Reparation d'articles personnels et domestiques n.c.a.",
                parent: 224
            },
            {
                value: 717,
                temp_id: "H5511",
                text: "Hôtels, motels, vvt et residences classes",
                parent: 225
            },
            {
                value: 718,
                temp_id: "H5512",
                text: "autres hebergements touristiques classes",
                parent: 225
            },
            {
                value: 719,
                temp_id: "H5513",
                text: "Hôtels non classes",
                parent: 225
            },
            {
                value: 720,
                temp_id: "H5521",
                text: "Auberges de jeunesse et refuges classes",
                parent: 226
            },
            {
                value: 721,
                temp_id: "H5522",
                text: "Exploitation de terrains de camping classes",
                parent: 226
            },
            {
                value: 722,
                temp_id: "H5523",
                text: "Autre herbergement touristique",
                parent: 226
            },
            {
                value: 723,
                temp_id: "H5524",
                text: "Hebergement collectif non touristique",
                parent: 226
            },
            {
                value: 724,
                temp_id: "H5531",
                text: "Restaurants classes",
                parent: 227
            },
            {
                value: 725,
                temp_id: "H5532",
                text: "Restauration complete",
                parent: 227
            },
            {
                value: 726,
                temp_id: "H5533",
                text: "Restauration simplifiee",
                parent: 227
            },
            {
                value: 727,
                temp_id: "H5534",
                text: "Restauration traditionnelle",
                parent: 227
            },
            { value: 728, temp_id: "H5541", text: "Cafes", parent: 228 },
            {
                value: 729,
                temp_id: "H5542",
                text: "Debits de boissons alcoolisees",
                parent: 228
            },
            {
                value: 730,
                temp_id: "I6011",
                text: "Transports ferroviaires de voyageurs",
                parent: 229
            },
            {
                value: 731,
                temp_id: "I6012",
                text: "Transports ferroviaires de marchandises",
                parent: 229
            },
            {
                value: 732,
                temp_id: "I6021",
                text: "Transports urbains de voyageurs par taxi",
                parent: 230
            },
            {
                value: 733,
                temp_id: "I6022",
                text: "Transports urbains de voyageurs par bus",
                parent: 230
            },
            {
                value: 734,
                temp_id: "I6023",
                text: "Autres transports routiers de voyageurs",
                parent: 230
            },
            {
                value: 735,
                temp_id: "I6024",
                text: "Transports routiers de marchandises",
                parent: 230
            },
            {
                value: 736,
                temp_id: "I6025",
                text: "Demenagement",
                parent: 230
            },
            {
                value: 737,
                temp_id: "I6026",
                text: "Location de camions avec conducteur",
                parent: 230
            },
            {
                value: 738,
                temp_id: "I6031",
                text: "Transports de voyageurs par autocars",
                parent: 231
            },
            {
                value: 739,
                temp_id: "I6032",
                text: "Transports de voyageurs par taxi",
                parent: 231
            },
            {
                value: 740,
                temp_id: "I6033",
                text: "Transport de marchandises",
                parent: 231
            },
            {
                value: 741,
                temp_id: "I6041",
                text: "Transport touristique par taxi",
                parent: 232
            },
            {
                value: 742,
                temp_id: "I6042",
                text: "Transport par autocars de luxe",
                parent: 232
            },
            {
                value: 743,
                temp_id: "I6051",
                text:
                    "Transport par autocars de 2eme categorie : (transports soukiers)",
                parent: 233
            },
            {
                value: 744,
                temp_id: "I6052",
                text: "Transport par taxi",
                parent: 233
            },
            {
                value: 745,
                temp_id: "I6053",
                text:
                    "Transport mixte (transport simultane de voyageurs et marchandises)",
                parent: 233
            },
            {
                value: 746,
                temp_id: "I6061",
                text: "Transport international routier de voyageurs",
                parent: 234
            },
            {
                value: 747,
                temp_id: "I6062",
                text: "Transport international routier de marchandises",
                parent: 234
            },
            {
                value: 748,
                temp_id: "I6070",
                text: "Transport par conduite",
                parent: 235
            },
            {
                value: 749,
                temp_id: "I6111",
                text: "Transports hauturiers de marchandises",
                parent: 236
            },
            {
                value: 750,
                temp_id: "I6112",
                text: "Transports hauturiers de personnes",
                parent: 236
            },
            {
                value: 751,
                temp_id: "I6121",
                text: "Transports côtiers de marchandises",
                parent: 237
            },
            {
                value: 752,
                temp_id: "I6122",
                text: "Transports côtiers de personnes",
                parent: 237
            },
            {
                value: 753,
                temp_id: "I6211",
                text: "Transport aerien regulier interieur",
                parent: 238
            },
            {
                value: 754,
                temp_id: "I6212",
                text: "Transport aerien regulier international",
                parent: 238
            },
            {
                value: 755,
                temp_id: "I6220",
                text: "Transports aeriens non reguliers",
                parent: 239
            },
            {
                value: 756,
                temp_id: "I6311",
                text: "Manutention",
                parent: 240
            },
            {
                value: 757,
                temp_id: "I6312",
                text: "Entreposage frigorifique",
                parent: 240
            },
            {
                value: 758,
                temp_id: "I6313",
                text: "Entreposage non frigorifique",
                parent: 240
            },
            {
                value: 759,
                temp_id: "I6321",
                text: "Gestion d'infrastructures de transports terrestres",
                parent: 241
            },
            {
                value: 760,
                temp_id: "I6322",
                text: "Services portuaires et maritimes",
                parent: 241
            },
            {
                value: 761,
                temp_id: "I6323",
                text: "Services aeroportuaires",
                parent: 241
            },
            {
                value: 762,
                temp_id: "I6330",
                text: "Agences de voyage",
                parent: 242
            },
            {
                value: 763,
                temp_id: "I6340",
                text: "Organisation du transport de fret",
                parent: 243
            },
            {
                value: 764,
                temp_id: "I6411",
                text: "Postes nationales",
                parent: 244
            },
            {
                value: 765,
                temp_id: "I6412",
                text: "Autres activites de courrier",
                parent: 244
            },
            {
                value: 766,
                temp_id: "I6421",
                text: "Telecommunications nationales",
                parent: 245
            },
            {
                value: 767,
                temp_id: "I6422",
                text: "Autres activites de telecommunications",
                parent: 245
            },
            {
                value: 768,
                temp_id: "J6511",
                text: "Banque centrale",
                parent: 246
            },
            {
                value: 769,
                temp_id: "J6512",
                text: "Autres intermediations monetaires",
                parent: 246
            },
            {
                value: 770,
                temp_id: "J6521",
                text: "Credit bail",
                parent: 247
            },
            {
                value: 771,
                temp_id: "J6522",
                text: "Distribution de credit",
                parent: 247
            },
            {
                value: 772,
                temp_id: "J6523",
                text: "Autres intermediations financieres n.c.a.",
                parent: 247
            },
            {
                value: 773,
                temp_id: "J6601",
                text: "Assurance-vie et capitalisation",
                parent: 248
            },
            {
                value: 774,
                temp_id: "J6602",
                text: "Caisses de retraite",
                parent: 248
            },
            {
                value: 775,
                temp_id: "J6603",
                text: "Autres assurances",
                parent: 248
            },
            {
                value: 776,
                temp_id: "J6710",
                text: "Auxiliaires financiers",
                parent: 249
            },
            {
                value: 777,
                temp_id: "J6720",
                text: "Auxiliaires d'assurance",
                parent: 250
            },
            {
                value: 778,
                temp_id: "K7011",
                text: "Promotion immobiliere",
                parent: 251
            },
            {
                value: 779,
                temp_id: "K7012",
                text: "Supports juridiques du programme",
                parent: 251
            },
            {
                value: 780,
                temp_id: "K7013",
                text: "Marchands de biens immobiliers",
                parent: 251
            },
            {
                value: 781,
                temp_id: "K7021",
                text: "Location de logements",
                parent: 252
            },
            {
                value: 782,
                temp_id: "K7022",
                text: "Location de terrains",
                parent: 252
            },
            {
                value: 783,
                temp_id: "K7023",
                text: "Location d'autres biens immobiliers",
                parent: 252
            },
            {
                value: 784,
                temp_id: "K7031",
                text: "Agences immobilieres",
                parent: 253
            },
            {
                value: 785,
                temp_id: "K7032",
                text: "Administration de biens immobiliers",
                parent: 253
            },
            {
                value: 786,
                temp_id: "K7033",
                text: "Supports juridiques de gestion de patrimoine",
                parent: 253
            },
            {
                value: 787,
                temp_id: "K7110",
                text: "Location de vehicules automobiles",
                parent: 254
            },
            {
                value: 788,
                temp_id: "K7121",
                text: "Location d'autres materiels de transport terrestre",
                parent: 255
            },
            {
                value: 789,
                temp_id: "K7122",
                text: "Location de materiels de transport par eau",
                parent: 255
            },
            {
                value: 790,
                temp_id: "K7123",
                text: "Location d'appareils de transport aerien",
                parent: 255
            },
            {
                value: 791,
                temp_id: "K7131",
                text: "Location de materiel agricole",
                parent: 256
            },
            {
                value: 792,
                temp_id: "K7132",
                text:
                    "Location de machines et equipements pour la construction",
                parent: 256
            },
            {
                value: 793,
                temp_id: "K7133",
                text:
                    "Location de machines de bureau et de materiel informatique",
                parent: 256
            },
            {
                value: 794,
                temp_id: "K7134",
                text: "Location de machines et equipements divers",
                parent: 256
            },
            {
                value: 795,
                temp_id: "K7140",
                text: "Location de biens personnels et domestiques",
                parent: 257
            },
            {
                value: 796,
                temp_id: "K7210",
                text: "Conseil en systemes informatiques",
                parent: 258
            },
            {
                value: 797,
                temp_id: "K7220",
                text: "Realisation de logiciels",
                parent: 259
            },
            {
                value: 798,
                temp_id: "K7230",
                text: "Traitement de donnees",
                parent: 260
            },
            {
                value: 799,
                temp_id: "K7240",
                text: "Activites de banques de donnees",
                parent: 261
            },
            {
                value: 800,
                temp_id: "K7250",
                text:
                    "Entretien et reparation de machines de bureau et de materiel informatique",
                parent: 262
            },
            {
                value: 801,
                temp_id: "K7260",
                text: "Autres activites rattachees a l'informatique",
                parent: 263
            },
            {
                value: 802,
                temp_id: "K7310",
                text:
                    "Recherche-developpement en sciences physiques et naturelles",
                parent: 264
            },
            {
                value: 803,
                temp_id: "K7320",
                text:
                    "Recherche-developpement en sciences humaines et sociales",
                parent: 265
            },
            {
                value: 804,
                temp_id: "K7411",
                text: "Activites juridiques",
                parent: 266
            },
            {
                value: 805,
                temp_id: "K7412",
                text: "Activites comptables",
                parent: 266
            },
            {
                value: 806,
                temp_id: "K7413",
                text: "Etudes de marche et sondages",
                parent: 266
            },
            {
                value: 807,
                temp_id: "K7414",
                text:
                    "Conseil pour les affaires et administration d'entreprises",
                parent: 266
            },
            {
                value: 808,
                temp_id: "K7421",
                text: "Activites d'architecture",
                parent: 267
            },
            {
                value: 809,
                temp_id: "K7422",
                text: "Metreurs, geometres",
                parent: 267
            },
            {
                value: 810,
                temp_id: "K7423",
                text: "Ingenierie, etudes techniques",
                parent: 267
            },
            {
                value: 811,
                temp_id: "K7431",
                text: "Contrôle technique automobile",
                parent: 268
            },
            {
                value: 812,
                temp_id: "K7432",
                text: "Essais et analyses techniques",
                parent: 268
            },
            {
                value: 813,
                temp_id: "K7440",
                text: "Publicite",
                parent: 269
            },
            {
                value: 814,
                temp_id: "K7450",
                text: "Selection et fourniture de personnel",
                parent: 270
            },
            {
                value: 815,
                temp_id: "K7460",
                text: "Enquêtes et securite",
                parent: 271
            },
            {
                value: 816,
                temp_id: "K7470",
                text: "Activites de nettoyage",
                parent: 272
            },
            {
                value: 817,
                temp_id: "K7481",
                text: "Activites photographiques",
                parent: 273
            },
            {
                value: 818,
                temp_id: "K7482",
                text: "Conditionnement a façon",
                parent: 273
            },
            {
                value: 819,
                temp_id: "K7483",
                text: "Secretariat, traduction et routage",
                parent: 273
            },
            {
                value: 820,
                temp_id: "K7484",
                text: "Organisation de foires et salons",
                parent: 273
            },
            {
                value: 821,
                temp_id: "K7485",
                text: "Services annexes a la production",
                parent: 273
            },
            {
                value: 822,
                temp_id: "L7511",
                text:
                    "Activites liees aux competences generales de l'administration",
                parent: 274
            },
            {
                value: 823,
                temp_id: "L7512",
                text:
                    "Activites liees aux competences specialisees de l'administration",
                parent: 274
            },
            {
                value: 824,
                temp_id: "L7521",
                text: "Affaires etrangeres",
                parent: 275
            },
            {
                value: 825,
                temp_id: "L7522",
                text: "Defense",
                parent: 275
            },
            {
                value: 826,
                temp_id: "L7523",
                text: "Justice",
                parent: 275
            },
            {
                value: 827,
                temp_id: "L7524",
                text: "Police",
                parent: 275
            },
            {
                value: 828,
                temp_id: "L7525",
                text: "Protection civile",
                parent: 275
            },
            {
                value: 829,
                temp_id: "L7530",
                text: "Securite sociale obligatoire",
                parent: 276
            },
            {
                value: 830,
                temp_id: "M8011",
                text: "Enseignement coranique",
                parent: 277
            },
            {
                value: 831,
                temp_id: "M8012",
                text: "Jardins d'enfants",
                parent: 277
            },
            {
                value: 832,
                temp_id: "M8021",
                text: "Premier cycle fondamental (primaire)",
                parent: 278
            },
            {
                value: 833,
                temp_id: "M8022",
                text: "Second cycle fondamental (College)",
                parent: 278
            },
            {
                value: 834,
                temp_id: "M8031",
                text: "Enseignement secondaire general (Lycee)",
                parent: 279
            },
            {
                value: 835,
                temp_id: "M8032",
                text: "Enseignement technique",
                parent: 279
            },
            {
                value: 836,
                temp_id: "M8040",
                text: "Enseignement superieur",
                parent: 280
            },
            {
                value: 837,
                temp_id: "M8050",
                text: "Formation professionnelle",
                parent: 281
            },
            {
                value: 838,
                temp_id: "M8061",
                text: "Ecoles de conduite",
                parent: 282
            },
            {
                value: 839,
                temp_id: "M8062",
                text: "Formation permanente et enseignements divers",
                parent: 282
            },
            {
                value: 840,
                temp_id: "N8511",
                text: "Activites hospitalieres",
                parent: 283
            },
            {
                value: 841,
                temp_id: "N8512",
                text: "Pratique medicale",
                parent: 283
            },
            {
                value: 842,
                temp_id: "N8513",
                text: "Pratique dentaire",
                parent: 283
            },
            {
                value: 843,
                temp_id: "N8514",
                text: "Activites des auxiliaires medicaux",
                parent: 283
            },
            {
                value: 844,
                temp_id: "N8515",
                text: "Soins hors d'un cadre reglemente",
                parent: 283
            },
            {
                value: 845,
                temp_id: "N8516",
                text: "Ambulances",
                parent: 283
            },
            {
                value: 846,
                temp_id: "N8517",
                text: "Laboratoires d'analyses medicales",
                parent: 283
            },
            {
                value: 847,
                temp_id: "N8518",
                text: "Centres de collecte et banques d'organes",
                parent: 283
            },
            {
                value: 848,
                temp_id: "N8520",
                text: "Activites veterinaires",
                parent: 284
            },
            {
                value: 849,
                temp_id: "N8531",
                text: "Action sociale avec hebergement",
                parent: 285
            },
            {
                value: 850,
                temp_id: "N8532",
                text: "Autres formes d'action sociale",
                parent: 285
            },
            {
                value: 851,
                temp_id: "O9001",
                text: "Epuration des eaux usees",
                parent: 286
            },
            {
                value: 852,
                temp_id: "O9002",
                text: "Enlevement et traitement des dechets",
                parent: 286
            },
            {
                value: 853,
                temp_id: "O9003",
                text: "Gestion des clos d'equarrissage",
                parent: 286
            },
            {
                value: 854,
                temp_id: "O9111",
                text: "Organisations patronales et consulaires",
                parent: 287
            },
            {
                value: 855,
                temp_id: "O9112",
                text: "Organisations professionnelles",
                parent: 287
            },
            {
                value: 856,
                temp_id: "O9120",
                text: "Syndicats de salaries",
                parent: 288
            },
            {
                value: 857,
                temp_id: "O9131",
                text: "Organisations religieuses",
                parent: 289
            },
            {
                value: 858,
                temp_id: "O9132",
                text: "Organisations politiques",
                parent: 289
            },
            {
                value: 859,
                temp_id: "O9133",
                text: "Organisations associatives n.c.a.",
                parent: 289
            },
            {
                value: 860,
                temp_id: "O9211",
                text: "Production de films",
                parent: 290
            },
            {
                value: 861,
                temp_id: "O9212",
                text: "Distribution de films cinematographiques",
                parent: 290
            },
            {
                value: 862,
                temp_id: "O9213",
                text: "Edition et distribution video",
                parent: 290
            },
            {
                value: 863,
                temp_id: "O9214",
                text: "Projection de films cinematographiques",
                parent: 290
            },
            {
                value: 864,
                temp_id: "O9220",
                text: "Activites de radio et de television",
                parent: 291
            },
            {
                value: 865,
                temp_id: "O9231",
                text: "Art dramatique, musique et arts plastiques",
                parent: 292
            },
            {
                value: 866,
                temp_id: "O9232",
                text: "Gestion de salles de spectacles",
                parent: 292
            },
            {
                value: 867,
                temp_id: "O9233",
                text:
                    "Maneges forains, parcs d'attractions et autres spectacles",
                parent: 292
            },
            {
                value: 868,
                temp_id: "O9240",
                text: "Agences de presse",
                parent: 293
            },
            {
                value: 869,
                temp_id: "O9251",
                text: "Gestion des bibliotheques",
                parent: 294
            },
            {
                value: 870,
                temp_id: "O9252",
                text: "Gestion du patrimoine culturel",
                parent: 294
            },
            {
                value: 871,
                temp_id: "O9253",
                text: "Gestion du patrimoine naturel",
                parent: 294
            },
            {
                value: 872,
                temp_id: "O9261",
                text: "Gestion d'installations sportives",
                parent: 295
            },
            {
                value: 873,
                temp_id: "O9262",
                text: "Activites des ports de plaisance",
                parent: 295
            },
            {
                value: 874,
                temp_id: "O9263",
                text: "Autres activites sportives",
                parent: 295
            },
            {
                value: 875,
                temp_id: "O9271",
                text: "Jeux de hasard et d'argent",
                parent: 296
            },
            {
                value: 876,
                temp_id: "O9272",
                text: "Autres activites recreatives",
                parent: 296
            },
            {
                value: 877,
                temp_id: "O9301",
                text: "Blanchisserie-teinturerie",
                parent: 297
            },
            {
                value: 878,
                temp_id: "O9302",
                text: "Coiffure et soins de beaute",
                parent: 297
            },
            {
                value: 879,
                temp_id: "O9303",
                text: "Services funeraires",
                parent: 297
            },
            {
                value: 880,
                temp_id: "O9304",
                text: "Activites thermales et de thalassotherapie",
                parent: 297
            },
            {
                value: 881,
                temp_id: "O9305",
                text: "Bains et autres soins corporels",
                parent: 297
            },
            {
                value: 882,
                temp_id: "O9306",
                text: "Autres services personnels",
                parent: 297
            },
            {
                value: 883,
                temp_id: "P9500",
                text: "Services domestiques",
                parent: 298
            },
            {
                value: 884,
                temp_id: "Q9900",
                text: "Activites extra-territoriales",
                parent: 299
            }
        ]
    },
    BuildingLegalForm: [
        {
            text: "Collectif",
            value: "Collectif"
        },
        {
            text: "Melk",
            value: "Melk"
        },
        {
            text: "Réforme agraire",
            value: "Réforme agraire"
        },
        {
            text: "Autes",
            value: "Autes"
        },
        {
            text: "Titré",
            value: "Titré"
        }
    ],
    MoyensCommerciaux: {
        strategiePrix: [
            {
                text: "Plus élevée",
                value: "Plus élevée"
            },
            {
                text: "Plus Faible",
                value: "Plus Faible"
            },
            {
                text: "Alignement",
                value: "Alignement"
            }
        ],
        choix1: [
            {
                text:
                    "Intensive - Rendre présent le produit dans un maximum de points de vente",
                value:
                    "Intensive - Rendre présent le produit dans un maximum de points de vente"
            },
            {
                text:
                    "Sélective - Choisir un nombre restreint de points de vente",
                value:
                    "Sélective - Choisir un nombre restreint de points de vente"
            },
            {
                text: "Exclusive - Points de vente dédiés au produit",
                value: "Exclusive - Points de vente dédiés au produit"
            }
        ],
        choix2: [
            {
                text: "Proximité - Points de vente",
                value: "Proximité - Points de vente"
            },
            {
                text: "En ligne - Présence sur le web",
                value: "En ligne - Présence sur le web"
            }
        ],
        cannauxComunication: [
            { name: "Bouche-à-oreille", code: "Bouche-à-oreille" },
            {
                name: "Flyers",
                code: "Flyers"
            },
            {
                name: "Site internet",
                code: "Site internet"
            },
            {
                name: "Publicité sur le web",
                code: "Publicité sur le web"
            },
            { name: "Affichage", code: "Affichage" },
            { name: "Radio", code: "Radio" },
            { name: "E-mailing", code: "E-mailing" },
            {
                name: "Communication via les réseau sociaux",
                code: "Communication via les réseau sociaux"
            },
            { name: "Evènements", code: "Evènements" }
        ]
    },

    ProgrammeDinvestissementPlanDeFinancement: {
        nonValueAssetOptions: [
            {
                language: "Frais préliminaire",
                libs: [
                    {
                        name: "Frais d'étude",
                        category: "Frais préliminaire",
                        value: 0
                    },
                    {
                        name: "Frais de garanties",
                        category: "Frais préliminaire",
                        value: 0
                    }
                ]
            },
            {
                language: "Frais d’approche",
                libs: [
                    {
                        name: "Droits de douane",
                        category: "Frais d’approche",
                        value: 0
                    },
                    {
                        name: "Transit",
                        category: "Frais d’approche",
                        value: 0
                    },
                    {
                        name: "Formation",
                        category: "Frais d’approche",
                        value: 0
                    },
                    {
                        name: "Transport",
                        category: "Frais d’approche",
                        value: 0
                    },
                    {
                        name: "Installation",
                        category: "Frais d’approche",
                        value: 0
                    }
                ]
            }
        ],
        ITMOOptions: [
            {
                name: "terrain",
                value: 0
            },
            {
                name: "Frais d'étude",
                value: 0
            },
            {
                name: "Aménagement et agencement",
                value: 0
            },
            {
                name: "ITMO",
                value: 0
            },
            {
                name: "Frais de garanties",
                value: 0
            },
            {
                name: "Droits de douane",
                value: 0
            },
            { name: "Transit", value: 0 },
            { name: "Formation", value: 0 },
            { name: "Transport", value: 0 },
            {
                name: "Installation",
                value: 0
            }
        ],
        intangibleAssetsOptions: [
            {
                name: "Fonds commercial",
                value: 0
            },
            {
                name: "Brevet",
                value: 0
            },
            {
                name: "Licence/logiciels",
                value: 0
            },
            {
                name: "Autres",
                value: 0
            }
        ],
        tangibleAssetsOptions: [
            {
                name: "terrain",
                value: 0
            },
            {
                name: "Terrain de gisement",
                value: 0
            },
            {
                name: "Construction bâtiment industriel",
                value: 0
            },
            {
                name: "Construction bâtiment administratif",
                value: 0
            },
            {
                name: "Aménagement et agencement",
                value: 0
            },
            {
                name: "Installations techniques",
                value: 0
            },
            {
                name: "Matériel et outillage",
                value: 0
            },
            {
                name: "Matériel de transport",
                value: 0
            },
            {
                name: "Mobilier de bureau",
                value: 0
            },
            {
                name: "Matériel informatique",
                value: 0
            }
        ]
    },
    ChargesDuPersonnel: {
        options: [
            {
                name: "Ingénieur ",
                code: "1",
                effective: null,
                salary: null,
                monthNumber: 12
            },
            {
                name: "Secrétaire administratif",
                code: "2",
                effective: null,
                salary: null,
                monthNumber: 12
            },
            {
                name: "Directeur général",
                code: "3",
                effective: null,
                salary: null,
                monthNumber: 12
            },
            {
                name: "Comptable",
                code: "4",
                effective: null,
                salary: null,
                monthNumber: 12
            },
            {
                name: "Acheteur",
                code: "5",
                effective: null,
                salary: null,
                monthNumber: 12
            },
            {
                name: "Commercial",
                code: "6",
                effective: null,
                salary: null,
                monthNumber: 12
            },
            {
                name: "Responsable technique",
                code: "7",
                effective: null,
                salary: null,
                monthNumber: 12
            }
        ]
    },
    ChiffresDaffairesPrevisionnels: {
        options: [
            {
                name: "Le CA des concurrents et les statistiques du secteur",
                code: "1"
            },
            {
                name: "Le résultat de mes recherches",
                code: "2"
            },
            {
                name: "Une expérience précédente",
                code: "3"
            },
            {
                name: "Des commandes, Mes objectifs",
                code: "4"
            },
            { name: "Ma capacité de production", code: "5" }
        ]
    },
    CADetails: {
        options: [
            { text: "Marchandise", value: "marchandise" },
            { text: "Bien produit", value: "produit" },
            { text: "Service", value: "service" }
        ]
    },

    labourCard: {
        options: [
            {
                name: "Ingénieur",
                value: null,
                salary: null,
                monthNumber: 12,
                code: "ingénieur"
            },
            {
                name: "Secrétaire administratif",
                value: null,
                salary: null,
                monthNumber: 12,
                code: "Secrétaire administratif"
            },
            {
                name: "Directeur général",
                value: null,
                salary: null,
                monthNumber: 12,
                code: "Directeur général"
            },
            {
                name: "Comptable",
                value: null,
                salary: null,
                monthNumber: 12,
                code: "Comptable"
            },
            {
                name: "Acheteur",
                value: null,
                salary: null,
                monthNumber: 12,
                code: "Acheteur"
            },
            {
                name: "Commercial",
                salary: null,
                value: null,
                monthNumber: 12,
                code: "Commercial"
            },
            {
                name: "Responsable technique",
                value: null,
                salary: null,
                monthNumber: 12,
                code: "Responsable technique"
            }
        ]
    },
    AutresChargesExterne: {
        options: [
            {
                name: "Location et charges locatives",
                value: null,
                code: "Location et charges locatives"
            },
            {
                name: "Electricité",
                value: null,
                code: "Electricité"
            },
            {
                name: "Eau",
                value: null,
                code: "Eau"
            },
            {
                name: "Taxe Locale",
                value: null,
                code: "Tax Local"
            },
            {
                name: "Transport",
                value: null,
                code: "Transport"
            },
            { name: "Téléphone", value: null, code: "Téléphone" },
            {
                name: "Redevances crédit de bail",
                value: null,
                code: "Redevances crédit de bail"
            },
            {
                name: "Frais de déplacement",
                value: null,
                code: "Frais de déplacement"
            },
            {
                name: "Publicité",
                value: null,
                code: "Publicité"
            },
            {
                name: "Frais bancaire",
                value: null,
                code: "Frais bancaire"
            },
            {
                name: "Prime d’assurance",
                value: null,
                code: "Prime d’assurance"
            },
            {
                name: "Taxe professionnelle",
                value: null,
                code: "Tax professionnelle"
            },
            {
                name: "IR",
                value: null,
                code: "IR"
            },
            {
                name: "Autres Taxes",
                value: null,
                code: "Autres Taxes"
            }
        ]
    }
};
